export default {
	Crud: {
		Create: "Crear",
		Read: "Leer",
		Update: "Actualizar",
		Delete: "Eliminar",
		List: "Listar",
		Additionals: "Adicionales",
		Modules: "M\u00F3dules",
	},
	NotPermissionPage: {
		NotPermissions: "¡No tienes permiso para esta opción!",
		NotPermissionsText: "Comuníquese con el administrador de la plataforma para obtener el permiso.",
		NotPermissionPlatform: "No tiene permisos para acceder a ésta plataforma",
	},
	NotAuthorizedPage: {
		Title: "No esta autorizado",
		Subtitle: "Por favor contacte al administrador, si quiere tener acceso.",
		SubtitleDatarutas:
			"Para poder seleccionar puntos de visita desde datarutas, primero necesitas iniciar sesión en tu cuenta.",
		SubtitleResourceDatarutas:
			"Para poder seleccionar recursos desde datarutas, primero necesitas iniciar sesión en tu cuenta.",
		ButtonText: "Volver al Ruteador",
		LogOut: "Cerrar Sesión",
		CompanyOperatingRange: "Las fechas de funcionamiento de la empresa están fuera del rango permitido.",
	},
	DefinesHowTheSelectedRoutesWill:
		"Define cómo se agendarán las rutas seleccionadas en Datarutas. Puede ser Estándar, con un punto de inicio y un destino final sin paradas intermedias, o Con Puntos de Parada, donde se incluyen puntos de interés a visitar antes del destino para realizar entregas o recogidas.",
	ListOfSchedules: "Lista de Agendas",
	SelectSchedule: "Selecionar Agenda",
	ListSchedules: "Listar Agendas",
	Manage: "Gestionar",
	IncludeDeposits: "Incluir depósitos en la exportación",
	Standard: "Estándar",
	WithWaypoints: "Con puntos de parada",
	Waypoint: "Punto de parada",
	In: "en",
	TypeOfSchedule: "Tipo de agendamiento",
	RouteId: "Ruta Id",
	FileName: "Nombre del archivo",
	OnlyAMaximumOf3VisitPoints:
		"Solo se permiten un máximo de 3 puntos de visita para el {n}. Elimina alguno de los seleccionados para continuar.",
	ThereAreNoVisitPointsAvailable:
		"No hay puntos de visita disponibles para el {n}. Por favor, agrégalos primero utilizando la opción correspondiente en",
	Cost: "Costo",
	Points: "Puntos",
	LimitvsServiceConsumption: "Consumo vs Límite",
	Last1Day: "Último día",
	Last7Days: "Últimos 7 días",
	LastMonth: "Último mes",
	ConsumptionPerService: "Consumo por servicio",
	Totalconsumption: "Consumo total",
	TotalSubscriptionMonthly: "Por suscripción mensual",
	RoutingService: "Enrutamiento",
	Matrix: "Matriz",
	MapMatching: "Coincidencia de Mapas",
	Isochrones: "Isocronas",
	FieldsWithTheIndicatedIconsAreCompatible:
		"Los campos con los íconos indicados son compatibles con ciertos ruteadores. Asegúrate de llenar esta información si planeas utilizarlos",
	RoadNetworkWithSouthAmerican:
		"Red vial con países de América del Sur como: Argentina, Bolivia, Brasil, Chile, Colombia, Ecuador, Guyana, Paraguay, Perú, Surinam, Uruguay y Venezuela.",
	ViewMeshesAndTheirStatus: "Ver mallas y su estado",
	Pending: "Pendiente",
	Available: "Disponible",
	NotAvailable: "No disponible",
	RepetitionsHaveBeenGeneratedCorrectly: "Las repeticiones se han generado correctamente",
	DeleteAssignment: "Eliminar asignación",
	AddRepeatFormatAndTimeWindow: "Agregar formato de repetición y ventana horaria",
	ViewRepetitionFormatAndTimeWindow: "Ver formato de repetición y ventana horaria asignada",
	Generate: "Generar",
	GenerationOfRepetitions: "Generación de repeticiones",
	RepeatFormat: "Formato de repetición",
	NoGroupAssigned: "Sin Grupo Asignado",
	GroupSearch: "Grupo",
	ExpandAll: "Expandir todo",
	CollapseEverything: "Colapsar todo",
	DurationRefersToTheTotalTimeTaken:
		"Duración se refiere al tiempo total que toma realizar una actividad o proceso desde su inicio hasta su finalización, expresado en horas. En términos simples, es el período de tiempo que transcurre mientras se lleva a cabo una tarea. Si deseas expresar la duración en días, esta debe convertirse a horas (por ejemplo, 1 día equivale a 24 horas).",
	WithoutOriginIdentification: "Sin identificación de origen",
	IdentificationOfOrigin: "Identificación de origen",
	IdentificationOfOriginText:
		"Campo para agrupar vehículos bajo una misma identidad de origen, facilitando la generación de varias rutas para un mismo vehículo. Este campo no es único ni requerido, lo que significa que puede haber múltiples vehículos con la misma identificación de origen.",
	IdentificationOfOriginVisitPointText:
		"Campo para agrupar puntos de visita bajo una misma identidad de origen, facilitando la generación de varias rutas para un mismo punto de visita. Este campo no es único ni requerido, lo que significa que puede haber múltiples puntos de visita con la misma identificación de origen.",
	ChooseOneOrMoreOfTheseObjectivesToCustomize:
		"Puedes elegir uno o varios de estos objetivos para personalizar la optimización según las necesidades de tu negocio, garantizando la máxima eficiencia y mejorando los resultados de la planificación logística.",
	BasicObjectives: "Objetivos básicos",
	OptimizationObjectives: "Objetivos de optimización",
	SelectBasicOrAdvancedObjectives: "Selecciona los objetivos básicos o avanzados para la optimización",
	MinimizeUnassigned: "Minimizar paradas no asignadas",
	MinimizeCost: "Minimizar costos",
	MinimizeDistance: "Minimizar distancias",
	MinimizeDuration: "Minimizar duración",
	MinimizeTourCount: "Minimizar número de tours",
	MaximizeTourCount: "Maximizar número de tours",
	MinimizeTravelDuration: "Minimizar duración de viaje",
	MaximumDiameter: "Diámetro máximo",
	MaximumDistance: "Distancia máxima",
	MaximumDistanceClusterText:
		"Define la distancia máxima (en metros) entre una recogida/entrega y su vecino más cercano en el cluster. Si una recogida/entrega se encuentra a esta distancia de otra recogida/entrega, el algoritmo puede considerar estas recogidas/entregas como parte del mismo clúster. El rango de valores disponible para este parámetro es de 0 a 75",
	MaximumDiameterClusterText:
		"Distancia máxima permitida entre dos recogidas/entregas cualesquiera del clúster, en metros. Esto asegura que el clúster no se haga demasiado grande en diámetro, incluso si las recogidas/entregas individuales están lo suficientemente cerca unas de otras. El rango de valores disponible para este parámetro es de 0 a 1000",
	ClusteredRouteParametersText:
		"En tour planning, agrupar los trabajos geográficamente cercanos en una sola parada crea rutas más eficientes al reducir el tiempo de viaje y minimizar el consumo de combustible. La reducción del tiempo de conducción permite realizar más trabajos y puede aumentar la cantidad de trabajos completados en un turno",
	ClusteredRouteParameters: "Parámetros de ruta agrupada",
	NoRoutingParametersAssigned: "No hay parámetros de ruta asignados",
	Meters: "Metros",
	Initial: "Inicial",
	End: "Final",
	ByAnticipation: "Por anticipación",
	ForTardiness: "Por tardanza",
	Penalty: "Penalización",
	TheStartDateMust: "La fecha de inicio debe estar dentro de la ventana horaria",
	TheEndDateMust: "La fecha final debe estar dentro de la ventana horaria",
	TheStartTimeMust: "La hora de inicio debe estar dentro de la ventana horaria",
	TheEndTimeMust: "La hora final debe estar dentro de la ventana horaria",
	OptimizationGroup: "Grupo de optimización",
	ControlPanel: "Panel de control",
	IfYouExitNowAndYouHaveUnsavedData:
		"Si sales ahora y tienes datos no guardados, perderás todo el progreso realizado. ¿Estás seguro de que deseas continuar?",
	NotSpecified: "No especificado",
	NoneOfTheAbove: "Ninguna de las anteriores",
	ValidatingTheInformationProvided: "Validando la información proporcionada...",
	LoadingVisitPoints: "Cargando puntos de visita",
	MaxSelectedResourcesReached: "Selección máxima de recursos alcanzada",
	ValidateField: "El campo {n} es obligatorio",
	ThereIsNoDataToDisplayPleaseTryToAddNewRecords:
		"No hay datos para mostrar. Por favor, intenta agregar nuevos registros",
	NoResultsWereFoundForYourSearch: "No se encontraron resultados para tu búsqueda",
	UserRecordWithId: "Registro de usuario con id",
	NotFound: "no encontrado",
	Or: "O",
	DropFile: "Soltar archivo",
	AllowedFileExtensions: "Extensiones de archivo permitidas",
	RealTimeTrafficData: "Datos de tráfico en tiempo real para la optimización",
	RealTimeTrafficDataText:
		"Esta opción permite que la optimización tenga en cuenta las condiciones actuales del tráfico, como cierres de carreteras, accidentes y tráfico intenso",
	TheMaximumFileSelectionForVehiclesHasBeenReached: "Se ha alcanzado la selección máxima de archivos para vehículos",
	VisitingPointsWereSuccessfullyAdded: "Puntos de visita fueron agregados exitosamente",
	VehiclesWereSuccessfullyAdded: "Vehículos fueron agregados exitosamente",
	TheMaximumFileSelectionPickup: "Se ha alcanzado la selección máxima de archivos para el servicio de recogida",
	TheMaximumFileSelectionDelivery: "Se ha alcanzado la selección máxima de archivos para el servicio de entrega",
	PickupPoints: "Puntos de recogida",
	DeliveryPoints: "Puntos de entrega",
	AllowedVehicleFiles: "Archivos de vehículos permitidos",
	AllowedPickupfiles: "Archivos de recogida permitidos",
	AllowedDeliveryFiles: "Archivos de entrega permitidos",
	AddVehicleStatistics: "Añadir estadísticas",
	DeterminesPageStatistics: "Determina si se añade una página con estadísticas generales del vehículo",
	RestoringOrder: "Restablecer el orden",
	SortAndSelectTheFieldsToBeExported:
		"Ordene los campos arrastrando y soltando, seleccione todos o algunos de ellos para exportarlos",
	ManageFields: "Gestionar campos",
	VehiclesUpdatedCorrectly: "Vehiculos actualizados correctamente",
	VisitingPointsCorrectlyUpdated: "Puntos de visita actualizados correctamente",
	UpdatingVisitPointsByUploadingFiles: "Actualización de puntos de visita mediante carga de archivos",
	UpdatingVehiclesByFileUpload: "Actualización de vehículos mediante carga de archivos",
	UserHasAFileUploadProcessInPlace:
		"Sr.Usuario tiene un proceso de cargue de archivo vigente.¿Estás seguro de abandonarlo?",
	YouWishToLeaveEven: "¿Desea salir aún faltando visitas para corregir?",
	ToAssignAVisitPoint: "Para asignar un punto de visita, deben tener un recurso asignado",
	ToAssignAnActivity: "Para asignar una actividad, deben tener un recurso asignado",
	ToAssignAnActivityOrVisitPoint:
		"Para asignar una actividad o punto de visita, las visitas deben tener asignado un recurso",
	Visit: "Visita",
	VisitsWithErrors: "Visitas con errores ",
	SearchResourceBy: "Buscar recurso por",
	SearchVisitPointBy: "Buscar punto de visita por",
	Unlimited: "Ilimitado",
	OpenrouteMesh: "Malla Openroute",
	Identification: "Identificación",
	StartDeposit: "Depósito Inicial",
	EndDeposit: "Depósito Final",
	TeamsTable: "Equipos de Trabajo",
	SkillsTable: "Habilidades",
	Capabilities: "Capacidades",
	SpecifyTheTypeOfServiceForTheSelectedVisitPoints:
		"Especifique el tipo de servicio para los puntos de visita seleccionados",
	ApiKey: "Clave api",
	RoutingNotification: "Ruteados",
	RoutingNotNotification: "No Ruteados",
	GoTo: "Ir a",
	ViewMore: "Ver más",
	CopiedTextErrors: "Datos copiado al portapapeles con éxito",
	ErrorInCopying: "Error al copiar",
	Errors: "Errores",
	Go: "Ir",
	Default: "Por Defecto",
	Undo: "Deshacer",
	ClickHereToVerify: "Haga clic aquí para verificar el estado del ruteo",
	Duplicate: "Duplicar",
	Label: "Etiqueta",
	Options: "Opciones",
	TypeLabel: "Escribe una etiqueta",
	Basics: "Básicos",
	ExportAll: "Exportar Todo",
	Return: "Volver",
	AcceptsNumbersAndTheDashSign:
		"Ingrese un formato válido para el nombre teniendo en cuenta que solo acepta números, letras y guiones bajos",
	FINALIZED: "FINALIZADO",
	ERROR: "ERROR",
	PROCESSING: "PROCESANDO",
	See: "Ver",
	DeliveryService: "Servicio de entrega",
	PickUpService: "Servicio de recogida",
	ShippingTypeDelivery: "Tipo de envío entrega",
	PickupShippingType: "Tipo de envío recogida",
	Selected: "Seleccionado",
	RemoveSelection: "Eliminar selección",
	ClearSelection: "Limpiar selección",
	ShowSelected: "Mostrar seleccionados",
	AssignTheCapacitiesFileUploadRouting:
		"Asigna las capacidades que seran utilizadas para los ruteos por cargue de archivos",
	AssignTheCapacitiesOptimizationRouting:
		"Asigna las capacidades que seran utilizadas para los ruteos por optimizacion",
	CreationDate: "Fecha de creación",
	Of: "de",
	For: "para",
	SearchSeparatedByCommas: "Buscar múltiples resultados ingresando datos separados por comas",
	Apply: "Aplicar",
	DELIVERY: "Entrega",
	PICKUP: "Recogida",
	TypeOfService: "Tipo de servicio",
	SelectAdditionalField: "Seleccionar campo adicional",
	NoResultsFoundFor: "No se encontraron resultados para",
	NoResultsFound: "No se encontraron resultados",
	Filters: "Filtros",
	NotAdditionalFields: "Objeto no tiene campos adicionales",
	LocationInformation: "Información de ubicación",
	SeeDetailedInformation: "Ver información detallada",
	PlatformStart: "Inicio de la plataforma",
	Check: "Verificar",
	Value: "Valor",
	TagValue: "Valor de la etiqueta",
	LabelHelp: "Nombre visible en el formulario",
	PropertyDefinition: "Definici\u00F3n de Propiedad",
	AdditionalFields: "Campos Adicionales",
	Priority: "Prioridad",
	SelectInitTime: "Seleccionar hora inicial",
	SelectEndTime: "Seleccionar hora final",
	Refresh: "Recargar",
	SearchBy: "Búsqueda por",
	NoDataAvailable: "Datos no disponibles",
	ErrorTitle: "Ocurrio un error",
	ErrorMessage: "Ocurrio un error. Porfavor intentelo de nuevo!",
	Minimize: "Minimizar",
	Maximize: "Maximizar",
	To: "para",
	ViewInPopup: "Ver en ventana emergente",
	LogOut: "Cerrar Sesión",
	Schedule: "Agendar",
	All: "Todos",
	Activities: "Actividades",
	Address: "Dirección",
	AddedOn: "Añadido",
	Back: "Atrás",
	CurrentPosition: "Posición actual",
	Modules: "Módulos",
	Configuration: "Configuración",
	Accept: "Aceptar",
	Cancel: "Cancelar",
	Country: "País",
	City: "Ciudad",
	Department: "Departamento",
	Province: "Provincia",
	Region: "Región",
	State: "Estado",
	Canton: "Cantón",
	Municipality: "Municipio",
	District: "Distrito",
	Commune: "Comuna",
	Name: "Nombre",
	Description: "Descripción",
	Warning: "Advertencia",
	Information: "Informaci\u00F3n",
	GeneralInformation: "Información general",
	Dashboard: "Dashboard",
	eCommerce: "eCommerce",
	Apps: "Apps",
	Todo: "Todo",
	Chat: "Chat",
	Email: "Correo electrónico",
	Username: "Nombre Usuario",
	Calendar: "Calendario",
	Format: "Formato",
	FullCalendar: "Full Calendar",
	SimpleCalendar: "Calendar simple",
	Shop: "Compras",
	ItemDetails: "Detalles de productos",
	Cart: "Carrito",
	WishList: "Lista de deseos",
	Checkout: "Pagos",
	UI: "UI",
	DataList: "Data List",
	ListView: "List View",
	ThumbView: "Thumb View",
	Grid: "Grid",
	Vuexy: "Vuexy",
	Vuesax: "Vuesax",
	Tailwind: "Tailwind",
	Colors: "Colores",
	Card: "Card",
	Basic: "Basic",
	Statistics: "Estadisticas",
	Analytics: "Analitica",
	CardActions: "Card Actions",
	CardColors: "Card Colors",
	Table: "Table",
	agGridTable: "agGrid Table",
	Components: "Componentes",
	Alert: "Alertas",
	Avatar: "Avatar",
	Badge: "Badge",
	Breadcrumb: "Breadcrumb",
	Button: "Botones",
	ButtonGroup: "Grupos de Botones",
	Chip: "Chip",
	Collapse: "Collapse",
	Dialogs: "Dialogos",
	Divider: "Divider",
	DropDown: "DropDown",
	List: "Listas",
	Loading: "Cargando...",
	Navbar: "Navbar",
	Notifications: "Notificaciones",
	Notification: {
		MarKAllRead: "Marcar todo como leído",
		NewNotifications1: "Notificaciones",
		NewNotifications2: "Nuevas",
		Notification: "Notificaci\u00F3n",
		Notifications: "Notificaciones",
		DeleteAllNotifications: "Eliminar todas las notificaciones",
		UPLOAD_FILE: "Notificaciones de cargue de archivo",
		DOWNLOAD_FILE: "Notificaciones de descarga de archivo",
		CREATE_OPTIMIZATION: "Notificaciones de nueva optimización",
		EVENT: "Notificaciones del calendario",
		New: "Nuevas",
		NewNotification: "Nueva Notificaci\u00F3n",
		AppNotifications: "Notificaciones de la Plataforma",
		NEW_EVENT: "NUEVA VISITA PROGRAMADA",
		EVENT_NOT_ASSIGNED: "VISITA NO ASIGNADA",
		RESCHEDULED_EVENT: "VISITA REPROGRAMADA",
		EVENT_IN_PROCESS: "VISITA EN PROCESO",
		EVENT_ENDED: "VISITA FINALIZADA",
		EVENT_CANCELLED: "VISITA CANCELADA",
		EVENT_ON_THE_WAY: "EN CAMINO A VISITA",
		EVENT_DELAYED: "EN DEMORA A VISITA",
		FINALIZED: "PROCESO FINALIZADO",
		LOADED: "ARCHIVO CARGADO",
		PROCESS: "PROCESANDO ARCHIVO",
		ERRORINFILE: "ERROR EN ARCHIVO",
		DOWNLOAD_FINALIZED: "Descarga Finalizada",
		PANIC_ALARM: "Alerta de pánico",
		PanicAlarmText: "Uno de los recursos en el campo informó una alarma de pánico",
		CheckOut: "Verificar",
		UPLOAD_FILE_PV: "Cargue de archivo puntos de visita",
		UPLOAD_FILE_OP: "Cargue de archivo optimizaciones",
		DONE_OP: "Optimización completada",
		PROCESSINGOPTIMIZATION: "PROCESANDO OPTIMIZACIÓN",
		OPTIMIZATIONERROR: "ERROR EN OPTIMIZACIÓN",
		NewNotificationGlobal: {
			Title: "Notificaciones nuevas de rutas completadas",
			Text: "Tiene nuevas rutas completadas, vea su panel de notificaciones",
		},
	},
	Pagination: "Paginacion",
	Popup: "Popup",
	Progress: "Progress",
	Sidebar: "Sidebar",
	Slider: "Slider",
	Tabs: "Tabs",
	Tooltip: "Tooltip",
	Upload: "Cargar",
	FormsAndTable: "Forms & Table",
	FormElements: "Form Elements",
	Select: "Seleccionar",
	SelectAll: "Seleccionar Todos",
	Submit: "Enviar",
	Switch: "Switch",
	Checkbox: "Checkbox",
	Required: "Requerido",
	Radio: "Radio",
	Input: "Input",
	NumberInput: "Number Input",
	Textarea: "Textarea",
	FormLayouts: "Form Layouts",
	FormWizard: "Form Wizard",
	FormValidation: "Form Validation",
	FormInputGroup: "Form Input Group",
	Pages: "Paginas",
	ItemsPerPages: "Elementos por paginas",
	Authentication: "Authentication",
	Register: "Register",
	ForgotPassword: "Forgot Password",
	LockScreen: "Lock Screen",
	Miscellaneous: "Miscellaneous",
	ComingSoon: "Coming Soon",
	Success: "Éxito",
	Error: "Error",
	404: "404",
	500: "500",
	NotAuthorized: "Not Authorized",
	Maintenance: "Maintenance",
	Profile: "Perfil",
	User: "Usuarios",
	View: "View",
	UserSettings: "Configuración de Usuario",
	ListOfUsers: "Lista de usuarios",
	CreateUser: "Crear usuario",
	UpdateUser: "Actualizar usuario",
	ViewUser: "Ver usuario",
	CompanySettings: "Configuración de Compañia",
	Invoice: "Facturas",
	FAQ: "FAQ",
	Search: "Busqueda",
	KnowledgeBase: "Knowledge Base",
	ChartsAndMaps: "Charts & Maps",
	Charts: "Charts",
	ApexCharts: "Apex Charts",
	chartjs: "chartjs",
	echarts: "echarts",
	chartist: "chartist",
	GoogleMap: "Google Map",
	Extensions: "Extensiones",
	QuillEditor: "Quill Editor",
	DragAndDrop: "Drag & Drop",
	Datepicker: "Datepicker",
	DatetimePicker: "Datetime Picker",
	AccessControl: "Control de acceso",
	I18n: "I18n",
	Languages: {
		Languages: "Idiomas",
		Language: "Idioma",
		Spanish: "Español",
		English: "Inglés",
		Portuguese: "Portugués",
	},
	Carousel: "Carrusel",
	Clipboard: "Clipboard",
	ContextMenu: "Context Menu",
	StarRatings: "Star Ratings",
	Autocomplete: "Autocomplete",
	Tree: "Tree",
	// "Import/Export": 'Import/Export',
	Import: "Import",
	Export: "Exportar",
	ExportSelected: "Export Selected",
	Others: "Others",
	MenuLevels: "Menu Levels",
	MenuLevel2p1: "Menu Level 2.1",
	MenuLevel2p2: "Menu Level 2.2",
	MenuLevel3p1: "Menu Level 3.1",
	MenuLevel3p2: "Menu Level 3.2",
	DisabledMenu: "Disabled Menu",
	Support: "Suporte",
	Documentation: "Documentacion",
	RaiseSupport: "Raise Support",
	demoTitle: "Card Title",
	demoText:
		"Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.",
	// Map Module
	Map: "Mapa",
	// Company Module
	Company: "Empresa",
	CompanyFormTitleCreate: "Formulario para crear una nueva empresa",
	CompanyFormTitleUpdate: "Formulario para actualizar una empresa",
	NewCompany: "Nueva Empresa",
	UpdateCompany: "Actualizar Empresa",
	ListOfCompanies: "Lista de Empresas",
	TitleConfirmCompanyCreate: "Empresa creada",
	TextConfirmCompanyCreate: "La empresa fue creada exitosamente",
	TitleConfirmCompanyDelete: "Empresa Eliminada",
	TextConfirmCompanyDelete: "La empresa seleccionada fue eliminada exitosamente",
	TitleConfirmCompanyUpdate: "Empresa Actualizada",
	TextConfirmCompanyUpdate: "La empresa seleccionada fue actualizada exitosamente",
	DeleteCompany: "¿Estas seguro de eliminar la empresa? Por favor aceptar para continuar.",
	Confirm: "Confirmar",
	MissingFieldTitle: "Campos faltantes",
	MissingField: "Faltan algunos campos en el formulario",
	CompanyCreate: {
		CompanyName: "Nombre Empresa",
		Address: "Dirección",
		Phone: "Teléfono",
		Nit: "NIT",
		InitDate: "Fecha Inicial",
		EndDate: "Fecha Final",
		ContactPerson: "Persona de Contacto",
		Country: "País",
		City: "Ciudad",
		Description: "Descripción",
		Create: "Crear",
		CreateFirstResourceAlert:
			"Ahora es necesario crear el primer recurso para la administración de la empresa. por favor diligencia el formulario.",
	},
	CompanyModule: {
		Add: "Añadir Nuevo",
		ManagingCompanies: "Administrar empresas",
		MissingServiceTime: "Tiempo de servicio restante",
		Month: "Mes",
		Year: "Año",
		Day: "Día",
		Months: "Meses",
		Years: "Años",
		Days: "Días",
		nameRequired: "El nombre es requerido",
		addressRequired: "La dirección es requerida",
		phoneRequired: "El teléfono es requerido",
		nitRequired: "El nit de la empresa es requerido",
		date_initRequired: "La fecha inicial es requerida",
		date_endRequired: "La fecha final es requerida",
		contac_personsRequired: "El contacto es requerido",
		cityRequired: "La ciudad es requerida",
		countryRequired: "El pais es requerido",
		descriptionRequired: "La descripción es requerida",
		InvalidFields: "Campos Inválidos",
		ChechInfo: "Verifique la información, si está bien, haga clic en el botón Guardar para finalizar el proceso.",
		ViewCompanyList: "Haga clic aquí para ir a la lista de empresas",
		AdminResource: "Recurso Administrador",
		AdminResourceSuccess: "Recurso administrador creado exitosamente",
		AdminResourceError: "Recurso administrador no fue creado",
		AdminResourceFailed:
			"Algo salió mal durante la creación del Recurso Administrador; Intente crearlo nuevamente desde la lista de empresas.",
		DateInitError: "La fecha inicial no puede ser mayor a la fecha final.",
		CompanyInformation: "Información  de la Empresa",
		Summary: "Resumen",
		Finish: "Finalizar",
		ActivateServiroutes: "Seleccione el recurso administrador para la activación de serviroutes.",
		ActivateSitidadaText1: "Es necesario activar SITIDATA para un correcto funcionamiento de la plataforma",
		ActivateSitidadaText2: "click aquí para agregar la configuración.",
		RequiredConfig: "Configuraciones Requeridas",
		EmailAlreadyExist: "Ya se encuentra un usuario registrado con este correo electrónico.",
		ValidEmail: "Correo electrónico válido",
		ReleationShip: "Relación con puntos de vista",
		Table: {
			Name: "Nombre",
			Nit: "Nit",
			City: "Ciudad",
			Address: "Dirección",
			Phone: "Teléfono",
			Actions: "Acción",
			TotalResources: "Recursos",
			Configuration: "Configuración",
			Configurations: "Configuraciones",
		},
		Form: {
			ValidMessages: {
				Name: "El campo nombre de la empresa es obligatorio",
				Address: "El campo dirección es obligatorio",
				Phone: "El campo teléfono es obligatorio y debe ser de tipo numérico",
				Nit: "El campo nit es obligatorio",
				InitDate: "El campo fecha inicial es obligatorio",
				EndDate: "El campo fecha final es obligatorio",
				ContactPerson: "El campo persona de contacto es obligatorio",
				Country: "El campo país es obligatorio",
				City: "El campo ciudad es obligatorio",
			},
			Labels: {
				Create: "Crear",
				Update: "Actualizar",
				Cancel: "Cancelar",
			},
		},
	},
	// Breaks Module
	Breaks: "Descansos",
	MinBreakDuration: "Duración mínima",
	SelectMinBreakDuration: "Seleccionar duración mínima",
	AddBreak: "Agregar descanso",
	ListOfBreaks: "Lista de Descansos",
	NewBreak: "Nuevo Descanso",
	TitleConfirmBreakCreate: "Descanso creado",
	TextConfirmBreakCreate: "El descanso fue creado exitosamente",
	TitleConfirmBreakDelete: "Descanso Eliminado",
	TextConfirmBreakDelete: "El descanso seleccionado fue eliminado exitosamente",
	TitleConfirmBreakUpdate: "Descanso Actualizado",
	TextConfirmBreakUpdate: "El descanso seleccionado fue actualizado exitosamente",
	DeleteBreak: "¿Estas seguro de eliminar el descanso? Por favor aceptar para continuar.",
	CreateBreak: "Crear Descanso",
	UpdateBreak: "Actualizar Descanso",
	visualizeBreak: "Visualizar descanso",
	AssignedBreaks: "Descansos Asignados",
	NoAssignedBreaks: "No hay descansos asignados",
	AssignBreaksTooltip: "Cargar el listado de descansos disponibles para continuar",
	DeleteAllBreaks: "Eliminar todos los descansos.",
	ThereAreCurrentlyNoBreaksAvailable:
		"Actualmente no hay descansos disponibles en la plataforma. Agrega uno nuevo utilizando la opción",
	BreakNotFound: {
		Title: "Descanso no encontrado",
		Text1: "Registro de descanso con id:",
		Text2: "no encontrado.",
	},
	BreakTable: {
		Name: "Nombre",
		Description: "Descripción",
		StartHour: "Hora de inicio",
		EndHour: "Hora Final",
		AssignResources: "Recursos Asignados",
		Action: "Acciones",
		Delete: "Borrar",
		Add: "Añadir Nuevo",
	},
	BreaksHour: "La hora inicial no puede ser mayor o igual a la hora final",
	BreakForm: {
		ValidMessages: {
			Name: "El campo nombre es obligatorio",
			InitHour: "La Hora inicial es obligatorio",
			EndHour: "La Hora final es obligatorio",
			InitHourEmpty: "La Hora inicial no puede estar vacia",
		},
		ErrorMessages: {
			Error: "Error",
			InitHourHeigh: "La hora inicial no puede ser mayor a la hora final",
			ValidInitHour: "La hora inicial debe ser menor que la hora final.",
			ValidEndHour: "La hora final debe ser mayor que la hora inicial.",
			DateInitError: "La fecha inicial no puede ser mayor a la fecha final.",
			ValidMinBreakDuration:
				"La duración mínima del descanso no puede exceder la duración total del período de descanso.",
		},
	},
	RemoveBreak: {
		Text1: "¿Estás seguro de que quieres eliminar el descanso",
		Text2: "Por favor aceptar para continuar.",
	},
	// Skills Module
	Skills: {
		Skill: "Habilidad",
		Skills: "Habilidades",
		AddSkill: "Agregar habilidad",
		ListOfSkills: "Lista de Habilidades",
		NewSkill: "Nueva Habilidad",
		AssignedSkills: "Habilidades asignadas",
		AssignSkill: "Asignar habilidad",
		AssignSkills: "Asignar habilidades",
		NoAssignedSkills: "No hay habilidades asignadas",
		AssigneSkillTooltip: "Cargar el listado de habilidades disponibles para continuar con la asignación",
		TotalSkills: "Total habilidades",
		NoSkillsAssigned: "No hay habilidades asignadas",
		LoadListOfVehiclesSkills: "Cargar lista de vehículos para asignar a habilidades",
		TherAreCurrentlyNoSkillsAvailable:
			"Actualmente no hay habilidades disponibles en la plataforma. Agrega una nueva utilizando la opción",
		Table: {
			Name: "Nombre",
			Description: "Descripción",
			Identifier: "Identificador",
			Action: "Acciones",
			Delete: "Borrar",
			Add: "Añadir Nuevo",
		},
		Messages: {
			Delete: "¿Estas seguro de eliminar la habilidad? Por favor aceptar para continuar",
			TitleConfirmDelete: "Habilidad Eliminada",
			TextConfirmDelete: "La habilidad seleccionada ha sido eliminada.",
			TitleConfirmCreate: "Habilidad Creada",
			TextConfirmCreate: "La habilidad fue creada exitosamente",
			TitleConfirmUpdate: "Habilidad Actualizada",
			TextConfirmUpdate: "La habilidad fue actualizada correctamente",
			DeleteAll: "¿Está seguro de quitar todos las habilidades de la tabla?",
		},
		CreateSkill: "Crear Habilidad",
		UpdateSkill: "Actualizar Habilidad",
		Form: {
			ValidMessages: {
				Name: "El campo nombre es obligatorio",
				Identifier: "El campo identificador es obligatorio",
				Description: "El campo descripción es obliatorio",
			},
		},
		DeleteSkill: {
			Text1: "¿Estas seguro de eliminar la habilidad",
			Text2: "Por favor aceptar para continuar.",
		},
	},
	// Capacity Module
	Capacity: {
		Capacity: "Capacidad",
		Capabilities: "Capacidades",
		CapabilityList: "Lista de capacidades",
		NewCapacity: "Nueva capacidad",
		AddCapacity: "Agregar capacidad",
		CreateCapacity: "Crear capacidad",
		UpdateCapacity: "Actualizar capacidad",
		AssignedCapacities: "Capacidades asignadas",
		AssignCapacity: "Asignar capacidad",
		AssignCapabilities: "Asignar capacidades",
		NoAssignedCapability: "No hay capacidades asignadas",
		AssigneCapacityTooltip: "Cargar el listado de capacidades disponibles para continuar con la asignación",
		TotalCapacities: "Total capacidades",
		NoAssignedCapacities: "No hay capacidades asignadas",
		ThereAreCurrentlyNoCapabilitiesAvailable:
			"Actualmente no hay capacidades disponibles en la plataforma. Agrega una nueva utilizando la opción",
		MassiveActionsCapacities:
			"Esta opción permite actualizar masivamente los valores de los campos de demanda y tipo de servicio en la lista de capacidades",
		Messages: {
			Delete: "¿Estás seguro de eliminar la capacidad? Por favor acepta para continuar",
			TitleConfirmDelete: "Capacidad Eliminada",
			TextConfirmDelete: "La capacidad seleccionada ha sido eliminada.",
			TitleConfirmCreate: "Capacidad Creada",
			TextConfirmCreate: "La capacidad fue creada exitosamente",
			TitleConfirmUpdate: "Capacidad Actualizada",
			TextConfirmUpdate: "La capacidad fue actualizada correctamente",
			DeleteAll: "¿Está seguro de quitar todos las capacidades de la tabla?",
		},
		DeleteCapacity: {
			Text1: "¿Estas seguro de eliminar la capacidad",
			Text2: "Por favor aceptar para continuar.",
		},
	},
	// Teams Module
	Teams: {
		Team: "Equipo de Trabajo",
		WithoutTeam: "Sin Equipo",
		Teams: "Equipos de Trabajo",
		AddTeam: "Agregar equipo",
		ListOfTeams: "Lista de Equipos",
		NewTeam: "Nuevo Equipo de Trabajo",
		ThereAreCurrentlyNoWorkTeamsAvailable:
			"Actualmente no hay equipos de trabajo disponibles en la plataforma. Agrega uno nuevo utilizando la opción",
		Table: {
			Name: "Nombre",
			Description: "Descripción",
			Action: "Acciones",
			Delete: "Borrar",
			Add: "Añadir Nuevo",
		},
		Form: {
			Label: "Etiqueta",
			Name: "Nombre",
			Type: "Tipo de dato",
			Add: "Agregar",
			ValidMessages: {
				Name: "El campo nombre es obligatorio",
				Description: "El campo descripción es obligatorio",
				AddProperty: "Complete los campos para agregar una nueva propiedad",
			},
		},
		Messages: {
			TitleConfirmCreate: "Equipo de trabajo creado",
			TextConfirmCreate: "El Equipo de trabajo fue creado exitosamente",
			TitleConfirmDelete: "Equipo de trabajo Eliminado",
			TextConfirmDelete: "El Equipo de trabajo seleccionado fue eliminado exitosamente",
			TitleConfirmUpdate: "Equipo de trabajo Actualizado",
			TextConfirmUpdate: "El Equipo de trabajo seleccionado fue actualizado exitosamente",
			TextDelete: "¿Estas seguro de eliminar el Equipo de trabajo? Por favor aceptar para continuar.",
		},
		CreateTeam: "Crear Equipo",
		UpdateTeam: "Actualizar Equipo",
	},
	// Deposits Module
	Deposits: {
		Depot: "Depósitos",
		Deposit: "Depósito",
		AddDeposit: "Agregar depósito",
		ListOfDeposits: "Lista de Depósitos",
		NewDeposit: "Nuevo Depósito",
		CreateDeposit: "Crear Depósito",
		UpdateDeposit: "Actualizar Depósito",
		NotFoundAddress:
			"La dirección ingresada no se encontró en el mapa, arrastre el marcador a la dirección deseada",
		Table: {
			Name: "Nombre",
			Description: "Descripción",
			Address: "Dirección",
			City: "Ciudad",
			Action: "Acciones",
			Delete: "Borrar",
			Add: "Añadir Nuevo",
		},
		Form: {
			Address: "Dirección",
			City: "Ciudad",
			CX: "Coordenada X",
			CY: "Coordenada Y",
			Latitude: "Latitud",
			Longitude: "Longitud",
			StartAtDeposit: "Inicia en Depósito",
			EndAtDeposit: "Termina en Depósito",
			StartDeposit: "Depósito Inicial",
			EndDeposit: "Depósito Final",
			AddResource: "Añadir Recurso",
			ValidMessages: {
				Name: "El campo nombre es obligatorio",
				Description: "El campo descripcion es obligatorio",
				Country: "El campo pais es obligatorio",
				Department: "El campo departamento es obligatorio",
				City: "El campo ciudad es obligatorio",
				Address: "El campo dirección es obligatorio",
				InitHourHigher: "La hora inicial no puede ser mayor a la hora final",
				ConfirmationMessage: "Mensaje de confirmación",
				AddressNotGeoRef: "La dirección no pudo ser georreferenciada confirme su dirección",
				AddressNotGeoRefSitidata:
					"La dirección no pudo ser georreferenciada confirme su dirección y valide que el servicio de sidata este activo.",
			},
			GeoRef: {
				Finded: "El georreferenciador encontró la siguiente dirección para las nuevas coordenadas:",
				UseVisitPoint: "¿Desea utilizar esta dirección para el punto de visita?",
			},
		},
		Messages: {
			TitleConfirmCreate: "Depósito creado",
			TextConfirmCreate: "El Depósito fue creado exitosamente",
			TitleConfirmDelete: "Depósito Eliminado",
			TextConfirmDelete: "El Depósito seleccionado fue eliminado exitosamente",
			TitleConfirmUpdate: "Depósito Actualizado",
			TextConfirmUpdate: "El Depósito seleccionado fue actualizado exitosamente",
			TextDelete: "¿Estas seguro de eliminar el Depósito? Por favor aceptar para continuar.",
			TextResources:
				"Recuerde: Si asignas un recurso a este depósito, y previamente fue asignado a otro, el depósito anterior será reemplazado por el actual.",
			DepositNotFound: "Depósito no encontrado",
			CountriesError: "No se obtuvieron los países",
			DepartmentsError: "No se obtuvieron los departamentos",
			CitiesError: "No se obtuvieron las ciudades",
			CityAndDirectionRequired: "Los campos ciudad y dirección son requeridos para Georeferenciar",
		},
		Labels: {
			StartInDeposit: "¿Inicia en Depósito?",
			EndInDeposit: "¿Termina en Depósito?",
			Resource: "Recurso",
		},
		Yes: "Si",
		Options: {
			StartAtDeposit: "Inicia en Depósito",
			EndAtDeposit: "Termina en Depósito",
			NotStartAtDeposit: "No inicia en Depósito",
			NotEndAtDeposit: "No termina en Depósito",
		},
	},
	// Status
	Status: {
		Title: "Estados",
		ListOfStatus: "Lista de Estados",
		CreateStatus: "Crear Estado",
		UpdateStatus: "Actualizar Estado",
		AddNew: "Añadir Nuevo",
		Create: "Crear",
		Form: {
			ValidMessages: {
				Name: "El campo nombre es obligatorio",
			},
		},
		Messages: {
			TitleConfirmCreate: "Creado",
			TextConfirmCreate: "El estado fue creado exitosamente.",
			TitleConfirmDelete: "Eliminado",
			TextConfirmDelete: "El estado seleccionado fue eliminado exitosamente",
			TitleConfirmUpdate: "Actualizado",
			TextConfirmUpdate: "El estado seleccionado fue actualizado exitosamente",
			TextDelete: "¿Estas seguro de eliminar el estado seleccionado? Por favor aceptar para continuar.",
		},
	},
	// Type Config
	TypeConfig: {
		Title: "Tipos de Configuración",
		Create: "Crear Tipo de Configuración",
		Update: "Actualizar Tipo de Configuración",
		List: "Lista de Tipos de Configuraciones",
		New: "Nuevo Tipo de Configuración",
		AddNew: "Añadir Nuevo",
		Form: {
			Name: "Nombre",
			Status: "Estado",
			Field: "Campo",
			ValidMessages: {
				Name: "El campo nombre es obligatorio",
				Status: "El campo estatus es obligatorio",
				Complete: "Complete el nombre del campo",
			},
		},
		Messages: {
			TitleConfirmCreate: "Tipo de Configuración creada",
			TextConfirmCreate: "Tipo de configuración creado exitosamente.",
			TitleConfirmDelete: "Tipo de Configuración Eliminado",
			TextConfirmDelete: "El Tipo de Configuración seleccionado fue eliminado exitosamente",
			TitleConfirmUpdate: "Tipo de Configuración Actualizada",
			TextConfirmUpdate: "El Tipo de Configuración seleccionado fue actualizado exitosamente",
			TextDelete: "¿Estas seguro de eliminar el Tipo de configuración? Por favor aceptar para continuar.",
			OneElement: "Debes agregar por lo menos 1 propiedad",
		},
	},
	//Tipology Module
	Tipology: "Tipolog\u00EDa",
	TextConfirmTipologyCreate: "La tipolog\u00EDa fue creada exitosamente",
	TextConfirmTipologyUpdate: "La tipolog\u00EDa fue modificada exitosamente",
	TextConfirmTipologyDelete: "La tipolog\u00EDa fue eliminada exitosamente",
	TitleConfirmTipologyCreate: "Tipolog\u00EDa Creada",
	TitleConfirmTipologyUpdate: "Tipolog\u00EDa Actualizada",
	TitleConfirmTipologyDelete: "Tipolog\u00EDa Eliminada",
	TextDeleteTipology: "¿Estas seguro de eliminar la tipolog\u00EDa",
	TextAccepContinue: "Por favor aceptar para continuar.",
	Save: "Guardar",
	Edit: "Editar",
	Remove: "Eliminar",
	Add: "Agregar",
	// Category Module
	Category: "Categor\u00EDa",
	NewCategory: "Nueva Categor\u00EDa",
	ListOfCategories: "Lista de Categor\u00EDas",
	TitleConfirmCategoryCreate: "Objeto Creado",
	TitleConfirmCategoryUpdate: "Objeto Actualizado",
	TitleConfirmCategoryDelete: "Objeto Eliminado",
	TextConfirmCategoryCreate: "El nuevo objeto fue creado con éxito",
	TextConfirmCategoryUpdate: "El objeto fue actualizado con éxito",
	TextConfirmCategoryDelete: "El objeto fue eliminada con éxito",
	// Resources Module
	Resource: "Recurso",
	Resources: "Recursos",
	CreateResource: "Crear Recurso",
	CreateFirstResource: "Crear Primer Recurso",
	CreateObject: "Crear Objecto",
	ViewResource: "Ver Recurso",
	ResourceModule: {
		TotalCost: "Costo total",
		TotalResourcesSelected: "Total recursos seleccionados",
		UpdateResource: "Actualizar recurso",
		UserNotFound: "Usuario no encontrado",
		NewResource: "Agregar Recurso",
		SelectTeamsResource: "Seleccione los equipos del recurso",
		AssignedResources: "Recursos Asignados",
		AssigResources: "Asignar Recursos",
		LoadListResources: "Cargar listado de recursos para asignar a las capacidades.",
		DeleteResource: "Eliminar Recurso",
		DeleteResources: "Eliminar Recursos",
		DeleteAllResources: "Eliminar todos los recursos",
		NotResources: "No hay recursos asignados",
		ResourceList: "Lista de Recursos",
		SelectedResourcesFrom: "Recursos seleccionados de",
		ResourceSelectedFrom: "Recurso seleccionado de",
		ShowOnlySelectedResources: "Mostrar sólo los recursos seleccionados",
		YouWantTheSelectedResourcesToBeRemoved:
			"Desea que los recursos seleccionados se eliminen del módulo de recursos al final del proceso de importación",
		ResourceSelectionwillBecomeObsolete:
			"La selección de recursos quedará obsoleta. Le invitamos a exportar sus recursos ejecutivos y supervisores al nuevo módulo de vehículos",
		MassiveActionsResource:
			"Esta opción le permite actualizar masivamente el valor del campo de demanda en los recursos seleccionados",
		BasicInfoForm: {
			ValidMessages: {
				Username: "El campo nombre de usuario es obligatorio",
				Identification: "El campo identificación es obligatorio",
				Name: "El campo nombre es obligatorio",
				LastName: "El campo apellidos es obligatorio",
				Role: "El campo rol es obligatorio",
				Status: "El campo estado es obligatorio",
				Email: "El campo correo electronico es obligatorio y debe ser válido",
				Country: "El campo país es obligatorio",
				Departament: "El campo departamento es obligatorio",
				Address: "El campo dirección es obligatorio",
				City: "El campo ciudad es obligatorio",
			},
			Messages: {
				NoCity: "La ciudad no puede estar vacia.",
				NoAddress: "La dirección no puede estar vacía.",
				SpecifyCity: "Especifique la ciudad para una mejor precisión.",
				AllFieldsRequired: "Todos los campos son obligatorios.",
				ClickGeoReference: "Debe hacer click en el boton de 'Georeferenciar'",
			},
		},
		CapacitiesActivities: {
			SubtitleActivities:
				"Asigne las horas de trabajo de los recursos, su hora de inicio y su hora de finalización del día.",
			SubtitleCapacities: "Asignar las capacidades del recurso actual.",
			Units: {
				Area: "Área",
				Volume: "Volumen",
				Kilos: "Kilos",
				Weight: "Peso",
				Free: "Libre",
			},
			CapacityValidMessages: {
				Title: "Capacidad",
				Number: "El valor de la capacidad debe ser de valor flotante",
				Empty: "Ingrese el nombre de la capacidad",
				ScoreEmpty: "Ingrese el valor decimal para la capacidad",
				ThreeCapacities: "Solo puede ingresar un máximo de 3 capacidades",
				SelectCapacity: "Seleccione una capacidad",
				EnterAmount: "Ingrese la cantidad",
			},
		},
		Skills: {
			Subtitle: "Seleccione las habilidades del recurso",
		},
		Breaks: {
			Subtitle: "Seleccione los descansos del recurso",
		},
		Deposits: {
			Subtitle:
				"Seleccione un depósito para la ruta inicial y final, para el recurso actual de la lista anterior.",
			InitialResourceDepot: "Depósito de recursos inicial:",
			FinalResourceDepot: "Depósito de recursos final:",
		},
		AdditionalFields: {
			ValidCompleteValues: "Ingrese todos los valores en los campos",
		},
		Create: {
			FinalHour: "Hora Final",
			ValidEndHour: "El campo hora final es obligatorio",
			InitialHour: "Hora Inicial",
			ValidInitialHour: "El campo hora inicial es obligatorio",
			Capacity: "Unidad",
			CapacityValue: "Cantidad",
			KeyValue: "Valor de la key",
			Label: "Etiqueta",
			LabelMessage: "Etiqueta informativa para el usuario",
			Type: "Tipo de dato",
			FieldValue: "Valor del campo",
			SelectResource: "Seleccionar Recursos",
			Add: "Agregar",
			Save: "Guardar",
			Clear: "Limpiar",
			Action: "Acción",
			Delete: "Eliminar",
			Next: "Siguiente",
			Back: "Atrás",
			SuccessText: "Recurso creado",
			Import: "Importar",
			ImportResources: "Importar Recursos de dataRutas",
			DataRutasResourceSelected: "Recurso Seleccionado:",
			ResourcesNotAvailable: "Recursos no disponibles por el momento",
			MaxServiceTime: "Tiempo de Servicio Máximo",
			MaxTravelDistance: "Distancia Máxima de Viaje",
			Previous: "Anterior",
		},
		Edit: {
			PageTitle: "Editar Recurso",
			Title: "Editar Información",
			Table: {
				Permissions: "Permisos",
				Module: "Módulo",
				Read: "Leer",
				Write: "Escribir",
				Create: "Crear",
				Delete: "Eliminar",
			},
			Save: "Guardar Cambios",
			Success: {
				Title: "Éxito",
				Text: "Recurso Actualizado",
			},
			Error: {
				Title: "Error",
				Text: "Los pasos 1 y 2 son obligatorios.",
				Text2: "Es obligatorio configurar la ventana horaria del recurso.",
				Email: "Ya existe una cuenta con ese correo.",
				Id: "Ya existe una cuenta con está identifiación",
				Username: "Ya existe una cuenta con este nombre de usuario.",
				Typology: "Por favor seleccionar la tipología",
				All: "Todos los campos son obligatorios",
				InitEndHoursReq: "La hora inicial y final del turno son obligatorias.",
			},
		},
		Table: {
			Id: "Id",
			Username: "Usuario",
			Name: "Nombre",
			Lastname: "Apellidos",
			Email: "Correo Electrónico",
			Role: "Rol",
			Status: "Estado",
			Actions: "Acciones",
			Identification: "Identificación",
			Address: "Dirección",
			City: "Ciudad",
			Department: "Departamento",
			Delete: "Borrar",
			Search: "Buscar...",
			AdditionalFields: "Campos Adicionales",
			Team: "Equipo de Trabajo",
			Optimizer: "Optimizador",
			Company: "Empresa",
			Type: "Tipo",
			Errors: {
				ConsultResources: "Error obteniendo los recursos",
				ConsultResource: "Error obteniendo el recurso",
				Delete: "No se elimino el recurso",
				ConsultSkills: "Obteniendo las habilidades",
				ConsultTeams: "Obteniendo los equipos",
				ConsultBreaks: "Obteniendo los descansos",
				ConsultDepots: "Obteniendo los depósitos",
			},
		},
		Messages: {
			TitleConfirmDelete: "Confirmar Eliminación",
			TitleDeleted: "Recurso eliminado",
			Delete: "Está seguro de eliminar el recurso: ",
			Deleted: "El recurso ha sido eliminado exitosamente.",
			AddProperties: {
				Success: {
					Title: "Campo agregado",
					Text: "El nuevo campo fue agregado con éxito",
				},
				Error: {
					Title: "Error al agregar",
					Text1: "No es posible agregar si los campos llave y etiqueta están vacios",
					Text2: "No puede agregar este campo, porque ya existe uno con el mismo nombre",
				},
			},
			RemoveProperties: {
				Title: "Campo eliminado",
				Text: "El campo seleccionado ha sido eliminado con éxito",
			},
		},
		Title: {
			SkillsOptional: "Habilidades (Opcional)",
			TeamsOptional: "Equipos (Opcional)",
			BreaksOptional: "Descansos (Opcional)",
		},
		Costs: {
			Subtitle: "Asignar las variables de costos al recurso actual.",
			"Fixed cost": "Costo fijo",
			"Cost per kilometer of the vehicle route": "Costo por kilómetro de recorrido",
			"Cost per hour of the vehicle route": "Costo por hora de ruta del vehículo",
			"Cost per traveled hour of the vehicle route": "Costo por hora recorrida de la ruta",
			KilometeOfTravel: "Kilómetro recorrido",
			Fixed: "Fijo",
			RoutingTime: "Hora de la ruta",
			TimeTraveled: "Hora recorrida",
		},
	},
	Routing: {
		Car: "Carro",
		Walker: "Caminante",
		Walking: "A pie",
		Bicycle: "Bicicleta",
		Motorcycle: "Motocicleta",
		Truck: "Camión",
		Bus: "Autobús",
		Scooter: "Patinete",
		MaxDuration: "Duración maxima (min)",
		MaxDistanceSpeed: "Velocidad máxima (km/h)",
		YearsAgo: "Hace {n} años ",
		YearAgo: "Hace 1 año",
		DaysAgo: "Hace {n} días",
		DayAgo: "Hace 1 día",
		HoursAgo: "Hace {n} horas",
		HourAgo: "Hace 1 hora",
		MinutesAgo: "Hace {n} minutos",
		MinuteAgo: "Hace 1 minuto",
		SecondsAgo: "Hace {n} segundos",
		SecondAgo: "Justo ahora",
		ROUTING_DONE: "Ruteo completado",
		ROUTING_ERROR: "Error en ruteo",
		ROUTING_PROCESS: "Ruteo en proceso",
		Resource: "Recurso",
		Routing: "Rutear puntos de visita",
		Point: "Punto",
		DistanceRoute: "Distancia",
		MinimumRouteTime: "Tiempo de ruta",
		Typology: "Tipología",
		SelectedColumns: "Columnas Seleccionadas",
		ModuleNotEnabled: "Módulo no habilitado",
		SelectTypeRouter: "Seleccione el modo de ruteo",
		VisitPointData: "Si el archivo es cargue de puntos de visita de Datarutas porfavor active la siguinte opción.",
		FromMapTitle: "Seleccione un punto del mapa haciendo clic en la posición deseada o arrastrando el marcador",
		FromMapAlert: "Seleccione un punto del mapa haciendo clic en la posición deseada",
		FromMap: "Habilita la funcion de poder seleccionar un punto desde el mapa haciendo clic donde se desee",
		CreateRouting: "Crear ruteo",
		Optimizer: "Optimizador",
		TypesOfOptimization: "Tipos de optimización",
		ListOfRoutingTypes: "Lista de tipos de ruteo",
		FileUploadRouting: {
			Title: "Ruteo por cargue de archivo",
			Subtitle:
				"Permite seleccionar un modo de ruteo (Ruteo Logístico, Ruteo Básico, Ruteo por Selección, Ruteo Datarutas) y luego cargar un archivo con un problema de enrutamiento de vehículos para obtener la mejor ruta.",
		},
		FileUploadOptimization: {
			Title: "Optimización por cargue de archivo",
			Subtitle:
				"Permite seleccionar un tipo de ruteo (Ruteo Logístico, Ruteo Básico, Ruteo por Selección, Ruteo Datarutas)",
		},
		CreateNewOptimization: {
			Title: "Crear nueva optimización",
			Subtitle:
				"Permite crear una nueva optimizacion con puntos de visitas y recursos registrados desde la plataforma",
		},
		DatarutasRouting: {
			Title: "Ruteo Datarutas",
			Subtitle:
				"El Ruteo Datarutas, te permitirá crear ruteos básicos con los puntos de visitas existentes en Datarutas.",
		},
		LogisticRouting: {
			Title: "Ruteo Logístico",
			Subtitle:
				"El Ruteo logístico, te permitirá cargar un archivo con los clientes a visitar y los vehículos disponibles contemplando ventanas horarias y capacidades de entrega para la mejor ruta.",
		},
		BasicRouting: {
			Title: "Ruteo Básico",
			Subtitle:
				"El Ruteo Básico, nos da una ruta óptima de acuerdo a la cercanía de los puntos mediante el API de Google Maps, con una secuenciación de punto a punto.",
		},
		RoutingBySelection: {
			Title: "Ruteo por Selección",
			Subtitle:
				"El Ruteo por Selección, te permitirá hacer una selección estratégica (concentración de puntos en el mapa) de puntos de visita desde el mapa, previamente obtenidos y ubicados desde un cargue archivo, un origen de datos de datarutas o de archivos previamente cargados.",
		},
		RoutingHistory: {
			Title: "Historial de Ruteo",
			Subtitle: "El historial de ruteo, permite visualizar los ruteos realizados por el usuario.",
			SubtitleView: "Visualizar los ruteos cargados por el usuario.",
			NoResults: "No se encontraron resultados, para crear tu primer ruteo haz clic",
			Here: "aquí",
			Unauthorized: "No Autorizado",
			UnauthorizedRouting: "Credenciales del ruteador no validas.",
			ErrorRoutingProcess: "Ocurrió un error durante el proceso de ruteo.",
			SuccessRoutingProcess: "Ruteo completado exitosamente.",
			RoutesEmpty: "No se encontraron datos de ruteos.",
		},
		CreateVisitPoint: {
			ServiceTime: "Tiempo de servicio",
			ValidServiceTime: "El campo tiempo de servicio es obligatorio",
			ReviewVisitPoints: "Revisar Puntos de Visita",
			ConfigureActivityForAll: "Configurar Actividad para Todos",
			ConfigureActivityForAllText: "Es necesario establecer una actividad para todos los registros.",
			ExportDataRutasVisitPoint: "Exportar Puntos de Visita de DataRutas",
			BulkAssign: "Asignación Masiva",
			DragFiles: "Arrastre sus archivos aquí o haga clic en esta área.",
			DeleteAsk: "¿Está seguro de que quieres eliminar el archivo?",
			Errors: {
				ValidateManually: "Validar manualmente",
				FindLagOptimizeAgain: "Encontramos un retraso, por favor presione optimizar nuevamente",
				SelectActivity: "Seleccione una actividad",
				DeleteRoute: "La ruta no ha sido eliminada",
				ErrorImporting: "Error al importar información",
			},
			Success: {
				VisitPointValidate: "Punto de Visita validado",
				Proccesing: "Procesando",
				NotifyRouteWillBeRouted: "Se le notificará cuando el archivo esté completamente enrutado",
				DeleteRoute: "La ruta ha sido eliminada exitosamente",
			},
		},
		Buttons: {
			Process: "Procesar Archivo",
			Next: "Siguiente",
			Optimize: "Optimizar",
			Reoptimize: "Reoptimizar",
			SeeRoute: "Ver Ruta",
			Validate: "Validar",
			OtherFields: "Añadir a otros campos",
			AddVisitPoint: "Añadir punto de visita",
			EditVisitPoint: "Editar",
			NextResources: "Siguiente, Selección de recursos",
			ExportRoute: "Exportar ruta",
			DownloadRoute: "Descargar ruta",
			Downloading: "Descargando...",
			SeeAllRoutes: "Ver rutas",
			Schedule: "Agendar",
			DeleteRoute: "Eliminar ruta",
			ReOptimizeRoutes: "Reoptimizar rutas",
			Discard: "Descartar ",
			DiscardChanges: "Descartar cambios",
		},
		Table: {
			Type: "Tipo",
			Name: "Nombre",
			AddedOn: "Fecha",
			Action: "Acción",
			Actions: "Acciones",
			Identification: "Identificación",
			Longitude: "Longitud",
			Latitude: "Latitud",
			EstimatedTimeArrival: "Tiempo estimado de llegada",
			EstimatedDepartureTime: "Tiempo estimado de salida",
			WaitingTime: "Tiempo de espera",
			DistanceFromPrevious: "Distancia parcial (km)",
			TotalDistanceTraveled: "Distancia total recorrida (km)",
			EstimatedStartTask: "Inicio estimado de la tarea",
			TimeService: "Tiempo servicio",
			TimeWindowInit: "Hora de inicio",
			TimeWindowEnd: "Hora de fin",
			Cx: "Latitud",
			Cy: "Longitud",
			Demand: "Demanda",
			InitHour: "Hora Inicial",
			EndHour: "Hora Final",
			Skills: "Habilidades",
			Row: "Fila Excel",
			Column: "Columna Excel",
			Error: "Error",
			Break: "Descanso",
			Depot: "Depósito",
			Pickup: "Recogida",
			Delivery: "Entrega",
		},
		Title: {
			ResourceList: "Lista de recursos",
			VisitPointsList: "Lista de puntos de visita",
			SelectFormat: "Seleccione un formato",
			Close: "Cerrar",
			MatchColumn: "Asignación de columnas",
			TableExample: "Muestra de datos del archivo cargado",
			TableExampleText:
				"Columnas y data encontrada en el archivo cargado, con el fin de tener valores de referencia para la asignación de equivalencias.",
			ProcessVisitPoints: "Procesar puntos de visita",
			EditVisitPoint: "Editar Punto de Visita",
			VisitPoints: "Puntos de visita",
			VisitPointsDatarutas: "Puntos de Visita Datarutas",
			VisitPointsLocations: "Ubicaciones Puntos de visita",
			Resources: "Recursos",
			OptimizeByTeam: "Filtrar por equipos",
			SelectResource: "Seleccione los recursos para exportar",
			Errors: "Encontramos errores",
			UploadVisitpoints: "Cargar puntos de visita",
			UploadVisitpointsList: "Lista de archivos cargados",
			ExportFromDataRutas: "Importar puntos de visita de DataRutas",
			RoutingHistory: "Historial de Ruteo",
			Schedule: "Agendamiento",
			RoutingMode: "Seleccione el modo de ruteo",
			RoutingType: "Seleccione el tipo de ruteo",
			Basic: "Básico",
			Logistic: "Logístico",
			Selection: "Selección",
			AssignBulkActivity: "Asignar Actividad Masiva",
			AssignActivity: "Asignar actividad a los puntos de visita seleccionados.",
		},
		Map: {
			SeeMap: "Ver Mapa",
			ShowMap: "Mostrar Mapa",
			HideMap: "Ocultar Mapa",
			MapAppearance: "Apariencia del mapa",
			Types: "Tipos de mapa",
			Styles: "Estilos",
			ClickToDownload: "Haga clic para descargar",
			Coordinates: "Coordenadas",
			Georeference: "Georreferenciar",
			Latitude: "Latitud",
			Longitude: "Longitud",
			GeoCoordinates: "Coordenadas geográficas",
			GeoreferencingByAddress:
				"Se ha habilitado la georreferenciación por dirección para encontrar las coordenadas y ubicarlas en el mapa, debe hacer",
			DiscardTheChanges: "O para descartar los cambios haga",
			CellAutoWith: "Ancho Automático de Celda",
			ExportRoute: {
				Error: "No se pudo exportar la ruta",
				Success: "Ruta exportada correctamente",
				DownloadError: "Error al descargar el archivo. Por favor, intenta nuevamente.",
			},
			Schedule: {
				OptionalDate: "Fecha",
				ClickToSchedule: "Haga clic para agendar",
				Success: "Visitas agendadas con exito, para verificar utilice el calendario de Datarutas",
				Error: "Ocurrió un error agendando las visitas, valide las fechas y las actividades del recurso.",
				ErrorOptimization:
					"Ocurrió un error agendando las visitas, verifiqué la opción de corregirlo y vuelva a agendar",
				FoundErrors: "Algunas visitas no fueron agendas.",
				NotScheduledVisits: "Visitas no agendas",
				ErrorResource:
					"Ocurrió un error agendando las visitas. Los recursos resaltados no fueron encontrados en Datarutas.",
				SameDate:
					"Intentar agendar para el mismo día puede causar que algunas visitas no sean agendadas, esto debido a que DATARUTAS no permite agendar visitas inferiores a la fecha y hora actual.",
				InitHourError: "La hora inicial debe ser mayor a la hora actual",
				VisitpointError: "El punto de visita no esta asignado al actual recurso",
				ResourceActivityError: "La actividad seleccionada no esta asignada al actual recurso",
				WeAreGeneratingTheSchedule: "Estamos generando el agendamiento. Por favor espera...",
			},
			VisitPoints: {
				Drop: "Soltar Punto de Visita",
				Dropped: "Punto de visita no ruteado",
				Identifier: "Identificador",
				TimeArrival: "Hora de llegada",
				Deposit: "Depositar",
			},
			DeleteRoute: {
				DeleteRouteAsk: "¿Está seguro de que desea eliminar la ruta actual?",
				Success: "Ruta eliminada exitosamente",
			},
		},
		RouteResult: {
			Title: "Resultado del ruteo",
			ResourcesRouted: "Recursos Ruteados",
			ResourcesNotRouted: "Recursos No Ruteados",
			RoutesTime: "Tiempo total de todas las rutas",
			TotalDistance: "Distancia Total",
			VisitPointsRouted: "Puntos de visita ruteados",
			VisitPointsNotRouted: "Puntos de visita no ruteados",
			TotalResources: "Total Recursos",
			TotalVisitPoints: "Total Puntos de Visita",
			TotalRoutings: "Total Ruteos",
			DrivingTimme: "Tiempo de Conducción",
			Load: "Carga",
			Capacities: "Capacidades",
			LoadCapacity: "Capacidad Cargada",
			SeeRoutes: "Ver Ruteos",
			HideRoutes: "Ocultar Ruteos",
			Routes: "Ruteos",
			HideRoute: "Ocultar ruta",
			ChangeColorRoute: "Cambiar color a la ruta",
			RespectPlannedRoute:
				"Esta opción seleccionada permite que el ruteador respete la ruta planificada o, de lo contrario, buscará una nueva ruta durante la reoptimización",
		},
		Messages: {
			MatchColumnSelectionRoutingP2Tooltip: "Mapea las columnas de tu archivo a los campos requeridos",
			upload_placeholder: "Arrastra aquí tu archivo o haz click para cargarlo desde tu computador.",
			MatchColumn:
				"Claves y valores equivalentes a los nombres de columna dados en el archivo a procesar, para enrutamiento.",
			MatchColumnSelectionRouting:
				"Asignación de equivalencias entre columnas encontradas en el archivo y las propiedades requeridas por el proceso de enrutamiento.",
			MatchColumnSelectionRoutingP2:
				"Seleccione a continuación de cada nombre columna encontrada en el archivo el valor correspondiente a la equivalencia del cargue.",
			MatchColumnSelectionRoutingP3:
				"A través de la opción 𝐚𝐝𝐝 del listado, podemos agregar las columnas como valores adicionales al resultado del proceso de enrutamiento, el resto de columnas se omitirán.",
			MatchColumnSelectionRoutingP4:
				"Una vez termianda la asignación, haga click en el boton 𝐆𝐮𝐚𝐫𝐝𝐚𝐫 para continuar con la selección en el mapa.",
			MatchColumnSelectionRoutingError: "Faltaron las siguientes equivalencias por asignar: ",
			MatchColumnSelectionRoutingErrorEquivalents: "Es necesario asignar las equivalencias de las columnas",
			MatchColumnSelectionRoutingErrorTitle: "Error Equivalencias",
			FileWithErrorsRoutingErrorTitle: "Archivo Contiene Errores",
			SelectedColumns:
				"Nombres de columnas que desea conservar y que aparecen en la respuesta de enrutamiento, el resto de campos se omitirán.",
			ErrorMsg: "Por favor corrige los siguientes errores e intenta subir el archivo de nuevo.",
			ErrorMsg2: "Por favor corrige los errores encontrados anteriormente e intenta subir el archivo de nuevo.",
			AlertRoutingHistory:
				'Recuerda que puedes volver a optimizar un ruteo previamente cargado, utilizando la función "optimizar" y seleccionando nuevos recursos.',
			AlertProccessing: "Estamos trabajando para optimizar tu ruteo, te notificaremos cuando este completado.",
			SelectSchedule: "Seleccione sus recursos para agendar",
			DataRutasVisitPointsSelect:
				"Esta es tu lista de puntos de visita en DataRutas, para crear un ruteo usando estos puntos, selecciónalos y elige un tipo de ruta",
			AssignEquivalents: "Asignación Equivalencias De Columnas",
			Required: "Requerida",
			InformationFound: "Información encontrada",
			ErrorsFound: "Errores encontrados en el cargue de información.",
			ErrorsNotFound: "Ningún error encontrado durante el proceso de carga de información.",
			ValidatorRequiredProperty: "Es una propiedad requerida",
			AlreadyRegistered: "Ya registrado(a)",
			DateLessThanCurrentDate: "La fecha debe ser mayor a la fecha actual",
			NotRegistered: "No registrada en el sistema",
			ValidatorAdditionalProperties: "Propiedad adicional no permitida, por favor eliminela",
			TooShortProperties: "Valor de la propiedad esta vacio o el contenido es demasiado corto",
			AddressCouldBeNotGeoreferenced: "La dirección no pudo ser georreferenciada",
			TimeDataFormat:
				"El formato no es válido, el formato correcto debe ser similar para fechas AAAA-mm-dd o para horas HH:mm:ss",
			IsNotInteger: "No es un valor entero válido",
			InitHourWindowGreater: "Ventana de hora inicial mayor que ventana de hora final",
			ValidDemands: "Nombres demandas permitidos por la plataforma",
			DemandsInFile: "Nombres demandas enviadas (Cabeceras de archivo)",
			InvalidDemands: "Demandas invalidas",
			InvalidDemandsNames:
				"Los nombres de las demandas en el archivo (Nombre de cabecera) no coinciden con ningún nombre de demandas permitido en la plataforma. Por favor modifique los nombres de cabecera teniendo en cuenta los nombres permitidos por la plataforma",
		},
		AssignColumns: {
			Text1: "El campo",
			Text2: "es requerido",
		},
		ValidateMessages: {
			Text: "¿Estás seguro de descartar los cambios realizados?",
			Yes: "Si",
			Not: "No",
		},
		HistoricalReOptimizationText:
			"La reoptimización se está ejecutando en segundo plano y la plataforma le notificará su estado a través del módulo de notificación",
		ValidateChangesReOptimize:
			"Ha realizado cambios para reoptimizar la ruta. ¿Está seguro de que desea salir y descartar los cambios?",
	},
	// Divipola
	Divipola: {
		Country: "País",
		Department: "Departamento",
		City: "Ciudad",
		Address: "Dirección",
		GeoSearch: "Georeferenciar",
		GeoAgain: "Georreferenciar de Nuevo",
		GeoSub: "Georrefrenciar y ubicar en el mapa la dirección ingresada.",
	},
	UploadFiles: {
		UploadFile: "Subir Archivo",
		File: "Archivo",
		UploadFiles: "Cargue de Archivos",
		UploadSuccess: "Cargue Exitoso",
		UploadSuccessMessage: "El archivo fue cargado con éxito.",
		UploadingFile: "Cargando archivo...",
		ProcessingFile: "Procesando archivo",
		Progress: "Progreso",
		Uploading: "Subiendo",
		Complete: "Completado",
		UploadSuccessful: "¡Carga exitosa!",
		RedirectingToMapping: "Redireccionando a la asignación de columnas...",
		PleaseWait: "Por favor espere...",
		UploadError: "Cargue Fallido",
		Mapping: "Mapeado",
		Required: "Requerido",
		Optional: "Opcional",
		RequiredFields: "Campos requeridos",
		SmartSuggestions: "Sugerencias",
		ClickToSelect: "Haz clic sobre una sugerencia para asignarla",
		NoColumnsAvailable: "No hay columnas disponibles",
		Columns: "Columnas",
		Records: "Registros",
		UploadErrorMessage:
			"Se produjo un error durante la subida del archivo, compruebe si el archivo tiene la estructura básica o descargue los archivos de ejemplo",
		UploadType: "Tipo de Cargue",
		UploadTypeSelectToltip: "Define el tipo de cargue de archivo.",
		UploadTypeObjectToltip: "Define la estructura del archivo a cargar teniendo en cuenta sus campos adicionales.",
		FormatFile:
			"Seleccione un archivo de ruteo para iniciar el proceso, solo se permiten los siguientes formatos: excel (.xlsx), json, csv y xml",
		SelectFile: "Seleccionar Archivo",
		UploadFileDragAndDrop: "Arrastre y suelte un archivo aquí",
		UploadSuccessTextAlert:
			"El archivo fue cargado con éxito, el sistema le notificara cuando finalice el proceso.",
		FileReadyToBeUploaded: "Archivo listo  para ser cargado.",
		Details: "Detalles",
		Size: "Tamaño",
		TypeInvalid: "Tipo de archivo inválido",
		TypeInvalidText: "El tipo del archivo seleccionado no es válido. Por favor ingrese un archivo de tipo Excel.",
		UploadFileText: "Cargar Puntos de Visita",
		Format: "Formato",
		Formats: "Formatos",
		Download: "Descargar",
		UploadTypeCountryTooltip: "Selecciona el país donde se georreferenciarán los puntos de visita a cargar.",
		DownloadFailed: "Descarga Fallida",
		DownloadFailedText: "Descarga fallida, archivo no encontrado o fue eliminado del servidor",
		FileNotFound: "Archivo no encontrado",
		DownloadFormat: "Descargar archivo base",
		DownloadFormatText:
			"Descargar un archivo base o plantilla en el formato seleccionado que contiene la estructura requerida para el tipo de cargue seleccionado",
		InvalidFormatFile: "Tipo de formato invalido",
		ListOfUploadedFiles: "Lista de archivos cargados",
		TitleConfirmDelete: "Archivo Eliminado",
		LoadMassiveAssignmentUploadFileError: "El archivo no tiene un formato valido para cargar la informaci\u00F3n",
		InvalidFormatFileText:
			"Por favor seleccione un archivo con el formato requerido, solo se permiten archivos en formato .xlsx, .xls, .csv, .txt, .json o .xml",
		DeleteUploadFile: {
			Text1: "¿Estas seguro de eliminar el archivo",
			Text2: "Por favor aceptar para continuar.",
		},
	},
	//
	Objects: "Objetos",
	NewObject: "Nuevo object",
	ListOfObjects: "Lista de objectos",
	TooltipSchemas: `El esquema define las propiedades mínimas que pueden tener los objetos dependiendo del tipo seleccionado.`,
	Config: "Config",
	// VisitPoint
	VisitPoint: "Punto de Visita",
	CreateVisitPoint: "Ruteador",
	// Activity
	Activity: "Actividad",
	ActivityList: "Lista de Actividades",
	CreateActivity: "Crear Actividad",
	TitleConfirmActivityCreate: "Actividad creada",
	TextConfirmActivityCreate: "La actividad fue creada exitosamente",
	TitleConfirmActivityDelete: "Actividad Eliminada",
	TextConfirmActivityDelete: "La actividad seleccionada fue eliminada exitosamente",
	TitleConfirmActivityUpdate: "Actividad Actualizada",
	TextConfirmActivityUpdate: "La actividad seleccionada fue actualizada exitosamente",
	DeleteActivity: "¿Estas seguro de eliminar la actividad? Por favor aceptar para continuar.",
	//Schedule
	TitleConfirmEventCreate: "Cita creada",
	TextConfirmEventCreate: "La cita fue creada exitosamente",
	TitleConfirmEventDelete: "Cita Eliminada",
	TextConfirmEventDelete: "La cita seleccionada fue eliminada exitosamente",
	TitleConfirmEventUpdate: "Cita Actualizada",
	TextConfirmEventUpdate: "La cita seleccionada fue actualizada exitosamente",
	DeleteEvent: "¿Estas seguro de eliminar la cita? Por favor aceptar para continuar.",
	PopupScheduleTitleCreate: "Crear nueva cita",
	PopupScheduleTitleUpdate: "Actualizar cita",
	MODULE_ROLE: {
		Role: "Rol",
		Roles: "Roles",
		Description: "Descripción",
		SelectRole: "Por favor seleccione un rol",
		Created: "Creado",
		Action: "Acciones",
		RoleList: "Lista de roles",
		TitleCrear: "Crear Rol",
		TitleUpdate: "Actualizar Rol",
		ErrorName: "*Por favor ingrese el nombre del rol",
		ErrorDescription: "*Por favor ingrese una descripción para el rol",
		labelName: "Nombre del rol",
		ValidName: "El campo nombre rol es obligatorio",
		labelAlias: "Alias",
		ValidAlias: "El campo alias es obligatorio",
		labelDescription: "Descripción",
		ValidDescription: "El campo descripción es obligatorio",
		Cancel: "Cancelar",
		Ok: "Aceptar",
		Update: "Actualizar",
		Add: "Añadir Nuevo",
		titleDelete: "Eliminar rol",
		msgDelete:
			"Esto podría generar conflictos con usuarios que tengan este rol \n¿Desea eliminar este rol de todas formas?",
		Removed: "Eliminado",
		msgRemoved: "El rol fue eliminado exitosamente",
		Hecho: "Credado",
		msgHecho: "El rol fue creado exitosamente",
		Change: "Actualizado",
		msgChange: "El rol fue actualizado exitosamente",
		ErrorMessages: {
			ConsultRoles: "Consultando los roles",
			ConsultPermission: "Consultando los permisos",
			ConsultRolePermissions: "Consultando las relaciones entre roles y sus permisos",
			msgChange: "El rol no ha sido actualizado",
			msgHecho: "El rol no ha sido creado",
		},
		UpdateForm: "Formulario para editar un rol",
	},
	MODULE_PERMISSION: {
		Permissions: "Permisos",
		Role: "Permiso",
		Description: "Descripción",
		ListOfPermissions: "Lista de permisos",
		Created: "Creado",
		Action: "Acciones",
		TitleCrear: "Crear Permiso",
		TitleUpdate: "Actualizar Permiso",
		ErrorName: "*Por favor ingrese el nombre del permiso",
		ErrorDescription: "*Por favor ingrese una descripción para el permiso",
		labelName: "Nombre del permiso",
		ValidName: "El campo nombre del permiso es obligatorio",
		labelDescription: "Descripción",
		ValidDescription: "El campo descripción es obligatorio",
		labelRol: "Seleccione los roles <b>(Opcional)</b>",
		Cancel: "Cancelar",
		Ok: "Aceptar",
		Create: "Crear",
		Update: "Actualizar",
		Add: "Crear Nuevo",
		titleDelete: "Eliminar permiso",
		msgDelete:
			"Esto podría generar conflictos con usuarios que tengan este permiso \n¿Desea eliminar este permiso de todas formas?",
		Removed: "Eliminado!",
		msgRemoved: "El permiso fue eliminado exitosamente",
		Hecho: "Credado!",
		msgHecho: "El permiso fue creado exitosamente",
		Change: "Actualizado",
		msgChange: "El permiso fue actualizado exitosamente",
	},
	MODULE_SOURCE: {
		Divider1: "Información básica",
		Availability: "Disponibilidad",
		Divider2: "Actividades",
		Divider3: "Capacidades",
		Divider4: "Información Adicional",
		Option: "*Opcional",
		legend1: "(puedes agregar un máximo de 3 capaciades)",
		Resource_type: "Tipo de recurso",
		id: "Identificación",
		names: "Nombres",
		lastName: "Apellidos",
		Select_rol: "Seleccione el rol",
		Select_status: "Seleccione el estado",
		User_name: "Nombre de usuario",
		Email: "Correo Electrónico",
		Country: "País",
		Departament: "Departamento",
		City: "Ciudad",
		address: "Dirección",
		Completed: "Campo completado",
		Obligatory: "*Campo obligatorio",
		Costs: "Costos",
	},
	DrawingTools: {
		Tools: "Herramientas",
		Circle: "Círculo",
		Polygon: "Polígono",
		Rectangle: "Rectángulo",
		RemoveShape: "Remover Figura",
		Selection: "Seleccionar",
		Polyline: "Polilinea",
		Help: "Ayuda",
	},
	RouterSelection: {
		RouterSelection: "Ruteador por selección",
		CheckedAll: "Seleccionar Todo",
		ActivityAssignment: "Asignación de Actividades",
		TotalVisitPointSelected: "Total puntos de visita seleccionados",
		AssignActivities: "Asignar Actividades",
		ActivityAssignmentInfo: "Es necesario asignar una actividad para poder continuar con el proceso.",
		Activities: "Actividades",
		Activity: "Actividad",
		Total: "Total",
		TotalVisitPointInside: "encontrados dentro de la zona",
		TotalVisitPointInsideToContinue: "Por favor, seleccione uno o mas puntos de visitas para continuar.",
		TotalResourceInsideToContinue: "Seleccione uno o más recursos para continuar.",
		VisitPoints: "Puntos de Visita",
		TitleConfirmRecordCreate: "Registro creado",
		TextConfirmRecordCreate: "El Registro fue creado exitosamente",
		TitleConfirmRecordDelete: "Registro Eliminado",
		TextConfirmRecordDelete: "El Registro seleccionado fue eliminado exitosamente",
		TitleConfirmRecordUpdate: "Registro Actualizado",
		TextConfirmRecordUpdate: "El Registro seleccionado fue actualizado exitosamente",
		DeleteRecordTextConfirm:
			"¿Estas seguro de eliminar el registro seleccionado? Por favor aceptar para continuar.",
		UpdateRecordTextConfirm:
			"¿Estas seguro de actualizar el registro seleccionado? Por favor aceptar para continuar.",
		UpdateAllRecordTextConfirm:
			"Dependiendo del total seleccionado, actualizar todos los registro seleccionados puede tardar un tiempo. ¿Estas seguro de continuar?",
		CleanMap: "Limpiar Mapa",
		validateStep1Error: "Es necesario seleccionar puntos de visita en el mapa para continuar con el proceso.",
		validateStep2Error: "Es necesario seleccionar recursos del listado para continuar con el proceso.",
		validateStep3Error:
			"Es necesario asignar una actividad a todos los puntos de visita para poder continuar con el proceso.",
		Step1Title: "Seleccionar Puntos De Visita",
		Step2Title: "Seleccionar Recursos",
		Step3Title: "Ejecutar Proceso",
		Hours: "Horas",
		Minutes: "Minutos",
		Seconds: "Segundos",
	},
	LoginModule: {
		CodeErrorGreater: "El campo del código no puede tener más de 6 caracteres", //'The code field may not be greater than 6 characters',
		CodeErrorToShort: "El campo de código debe tener al menos 6 caracteres", // 'The code field must be at least 6 characters',
		CodeErrorRquired: "El campo de código es requerido", // 'The code field is required',
		CodeErrorAlphaNum: "El campo de código solo puede contener caracteres alfanuméricos",
	},
	// Company Config Module
	CompanyConfigCrud: "Configuración de la empresa",
	CompanyAddNewField: "Agrear un campo adicional",
	CompanyConfigCrudFormTitleCreate: "Formulario para crear una configuración de empresa",
	CompanyConfigCrudFormTitleEdit: "Formulario para editar una configuración de empresa",
	CompanyConfigCrudFormTitle: "Formulario para crear una configuración de empresa",
	CompanyConfNameAddLabel: "Nombre del campo",
	CompanyConfValueAddLabel: "Valor",
	CompanyConfNameAddValidMessage: "Solo caracteres alfabéticos, sin espacios",
	CompanyConfValueAddValidMessage: "Por favor ingresar valor",
	DeleteCompanyConf: "¿Esta seguro de eliminar la configuración de empresa?",
	TitleConfirmCompanyConfigDelete: "Configuración de Empresa Eliminada",
	TextConfirmCompanyConfigDelete: "La configuración seleccionada fue eliminada exitosamente",
	TitleConfirmCompanyConfigCreate: "Empresa de configuración creada",
	TextConfirmCompanyConfigCreate: "La configuración se creó con éxito",
	TitleConfirmCompanyConfigUpdate: "Empresa de configuración actualizada",
	TextConfirmCompanyConfigUpdate: "La configuración seleccionada se actualizó correctamente",
	NewCompanyConfig: "Nueva configuración de Empresa",
	UpdateCompanyConfig: "Actualizar Configuración de Empresa",
	ListOfCompaniesConfig: "Lista de Configuraciones de Empresa",
	TitleWarningExistPropertyCompanyConfig: "Ya existe",
	TextWarningExistPropertyCompanyConfig: "El valor a ingresar ya se encuentra",
	ListCompanyConfig: {
		TypeConfigName: "Nombre tipo de configuración",
	},
	ErrorFields: {
		Title: "Error en campos",
		Text: "Algunos campos faltan o no son válidos",
	},
	RoutingType: {
		Fleetrouting:
			"Herramienta de optimización creada por Google, diseñado para abordar los problemas más difíciles del enrutamiento de vehículos, flujos, programación entera y lineal.",
		RutaOptima:
			"Optimizador de rutas por defecto creado por Servinformacion, basado en OR-Tools, es una suite de herramientas de código abierto.",
		OpenRoute: "Optimizador de rutas de código abierto.",
		AvailableRoutingTypes: "Ruteadores Disponibles",
		SelectRoutingType: "Seleccione el tipo de ruteador",
		AskMeAgain: "Preguntarme de nuevo",
		SelectedRouter: "Ruteador Seleccionado",
		RoutingType: "Tipo de ruteador",
		MaximizeWindow: "Maximizar ventana",
		TourPlanning:
			"HERE Tour Planning, proporciona recorridos optimizados en tiempo o costo para todos los vehículos de una flota, incorporando el tipo y la capacidad del vehículo para maximizar la utilización. Optimización de vehículos habilitada para el tráfico en vivo, utilizando atributos de camiones cuando corresponda.",
		SelectMeansTransport: "Selecciona tu medio de transporte",
		SelectMeansTransportText: "¿Què medio de transporte vas a utilizar para optimizar las rutas?",
		Transport: "Medio de transporte",
	},
	Login: {
		Subtitle: "Bienvenido, inicia sesión para usar la plataforma.",
		Email: "Correo",
		Password: "Contraseña",
		Remember: "Recuérdame",
		ForgotPassword: "Olvido su contraseña?",
		Register: "Registrarse",
		Disabled: "La cuenta de usuario ha sido bloqueada por el administrador.",
		Login: "Iniciar Sesión",
		ConnectingWithDatarutas: "Conectando con Datarutas...",
		YouHaveSuccessfullyLoggedInToDatarutas:
			"¡Te has conectado correctamente a Datarutas! Ahora puedes continuar con tus actividades",
		CouldNotConnectToDatarutas:
			"No se pudo conectar a Datarutas. Por favor, verifica tu conexión a internet e inténtalo nuevamente. Si el problema persiste, comuníquese con el administrador de la plataforma.",
		ValidMessages: {
			Email: "El campo correo electrónico es requerido y debe ser un correo válido",
			Password: "La contraseña es requerida, mínimo 6 caracteres - máximo 18",
			InvalidPassword: "La contraseña es invalida o el usuario no tiene una asignada",
			UserNotFound: "Algo salio mal validando las credendiales",
			TooManyRequests:
				"Se ha deshabilitado temporalmente el acceso a este usuario debido a muchos intentos fallidos de inicio de sesión. Puede restaurarla inmediatamente restableciendo su contraseña o puede intentarlo de nuevo más tarde",
			CompanyReachedWorkingDate: "La empresa alcanzó la fecha de trabajo",
			InvalidCode: "Código de autenticación inválido",
		},
		LoginWithGoogle: "Iniciar sesión con cuenta Google",
		EnableTwoFactorAuthentication: "Habilitar doble factor de autenticación",
		TwoFactorAuthentication: "Doble factor de autenticación",
		TwoFactorAuthenticationText:
			"Ingrese el código de 6 dígitos que se le envió al correo electronico para continuar con la autenticación",
		ResendAuthCodeEmail: "Si el mensaje con el código de autenticación no ha llegado, puedes solicitar un reenvío.",
		ResendCode: "Reenviar código",
		CodeSent: "Código de verificación enviado",
		CustomTokenMissing: "No se recibió el token de autenticación. Por favor, inicia sesión nuevamente.",
		FirebaseAuthError: "Error al autenticar con Firebase.",
		Warning: "Advertencia",
		ServerError: "Ocurrió un error al contactar con el servidor.",
	},
	RecoverPassword: {
		Title: "Recuperar contraseña",
		Subtitle:
			"Ingrese su dirección de correo electrónico y le enviaremos instrucciones sobre cómo restablecer su contraseña.",
		Email: "Correo",
		ToLogin: "Iniciar Sesión",
	},
	ResetPassword: {
		TitleReset: "Restablecer contraseña",
		TitleCreate: "Crear contraseña",
		Subtitle: "Ingrese su nueva contraseña.",
		VerificationCode: {
			Title: "Codigo de verificación",
			Text1: "Se envió un código de verificación al correo electrónico. si no llega el código,",
			Text2: "envíelo de nuevo",
		},
		Code: "Código",
		YourPassword: "Tu contraseña",
		ConfirmPassword: "Confirmar contraseña",
		ToLogin: "Iniciar Sesión",
		Reset: "Reiniciar",
		ValidPassword1: "El campo de la contraseña debe tener al menos 6 caracteres",
	},
	Indicators: {
		Indicators: "Indicadores",
		IndicatorList: "Lista Indicadores",
		TitleConfirmIndicatorCreate: "Crear Indicador",
		TextConfirmIndicatorCreate: "El indicador fue creado exitosamente",
		TitleConfirmIndicatorDelete: "Eliminar Indicador",
		TextConfirmIndicatorDelete: "El indicador seleccionado fue eliminado exitosamente",
		TitleConfirmIndicatorUpdate: "Editar Indicador",
		TextConfirmIndicatorUpdate: "El indicador seleccionado fue actualizado exitosamente",
		DeleteIndicator: "¿Estas seguro de eliminar el indicador? Por favor aceptar para continuar.",
		UpdateIndicator: "Editar Indicador",
		CreateIndicator: "Crear Indicador",
		Visualizer: "Visualizador",
		AlertVisualizar: "Visualizar Indicador",
		AlertVisualizarInfo: "Para ver un indicador, haga clic en el elemento de la lista que desee ver.",
		IndicatorNotFound: "No se econtraron indicadores para listar",
	},
	AssignedTeams: {
		Teams: "Equipos",
		TotalTeams: "Total Equipos",
		Team: "Equipo",
		AssignedTeam: "Asignar Equipo",
		AssignTeams: "Asignar Equipos",
		AssignedTeams: "Equipos Asignados",
		NoAssignedTeams: "No hay equipos asignados",
		AssignedTeamToltip: "Cargar el listado de Equipos disponibles para continuar con la asignaci\u00F3n.",
		ShowAssignedTeam: "Ver Equipos Asignados",
		ShowAssignedTeamToltip: "Ver listado de Equipos actualmente asignados a esta operaci\u00F3n.",
		AssignedTeamRequired: "La asignaci\u00F3n de Equipo es requerida",
		ClickOnButton: "Click en el bot\u00F3n",
		DeleteAllTeams: "Eliminar todos los Equipos",
		Columns: "Columnas",
		ColumnsText: "Seleccione las columnas que desea renderizar en la tabla",
	},
	VisitPoints: {
		CreateVisitPoint: "Crear punto de visita",
		UpdatePointofVisit: "Actualizar punto de visita",
		Add: "Añadir",
		Georeferencer: "Georreferenciador",
		AddressCouldBeNotGeoreferenced: "La dirección no pudo ser georreferenciada",
		SitidataGeoreverseToken: "El token georeverse de Sitidata api no está habilitado para este pais",
		SitidataNoEnabled: "El API de SITIDATA no está habilitada para esta empresa.",
		Search: "Buscar",
		YouAreAboutToDeleteTheVisitPoint: "Está a punto de eliminar el registro con identificación",
		AllVisitPoints: "Todos los puntos de visita",
		ViewPointOfVisit: "Visualizar punto de visita",
		ListVisitPoint: "Lista Puntos de Visita ",
		Assig: "Asignar",
		AssignVisitPoints: "Asignar puntos de visita",
		AssignedVisitPoint: "Punto de visita Asignado",
		AssignedVisitPoints: "Puntos de visita Asignados",
		NoAssignedVisitPoints: "No hay puntos de visita asignados",
		AssigneVisitPointText: "Seleccione los puntos de visita que desea asignar.",
		AssignVisitPointToltip: "Cargar el listado de puntos de visita disponibles para continuar",
		AssignAllVisitPointText: "Asignar todos los puntos de visita de la plataforma",
		SelectObjectType: "Seleccionar tipo de objeto",
		ObjectType: "Tipo de objeto",
		DeleteAllVisitPoints: "Eliminar todos los puntos de visita.",
		DeleteAllText: "Estás a punto de borrar todos los",
		SelectedPointsOf: "Puntos Seleccionados de",
		SelectedPointOf: "Punto Seleccionado de",
		ShowOnlySelectedVisitPoints: "Mostrar sólo los puntos de visita seleccionados",
		VisitingPointsSelected: "Puntos de visita seleccionados",
		SelectedInformation: "Información seleccionada",
		Demands: "Demandas",
		Location: "Ubicación",
		MassiveActionsVisitPoints:
			"Esta opción permite actualizar masivamente los valores de los campos de demanda y tipo de servicio en los puntos de visita seleccionados",
		MakeMassiveSelectionFromPickupToDelivery:
			"Seleccionar masivamente los puntos de visita seleccionados en el servicio de entrega",
		MakeMassiveSelectionFromDeliveryToPickup:
			"Seleccionar masivamente los puntos de visita seleccionados en el servicio de recogida",
		FindAddress: {
			Title: "Dirección Encontrada",
			Text: "Dirección georeferenciada exitosamente.",
		},
		ErrorFindAddress: {
			Title: "Dirección no Encontrada",
			Text: "El georeferenciador no encontro la direccion ingresada",
		},
		MissingAddress: {
			Title: "Dirección Requerida",
			Text: "La dirección es requerida por el georreferenciador.",
		},
		ErrorFindCountry: {
			Title: "Cobertura no encontrada",
			Text: "Verifique que el país elegido coincida con el país donde está arrastrando el marcador",
		},
		Success: {
			Title: "Punto de visita creado",
			Text: "Punto de visita creado exitosamente",
		},
		EditSuccess: {
			Title: "Punto de visita actualizado",
			Text: "El punto de visita se actualizó correctamente",
		},
		ErrorRegisterValidate: {
			Title: "Campos faltantes",
			Text: "Campos faltantes en información adicional",
		},
		ValidData: {
			Title: "Valide los datos",
			Text: "Faltan algunos campos importantes",
		},
		CellRenderer: {
			DeleteRecord: "Está a punto de eliminar",
			DeleteSuccess: {
				Title: "Punto de Visita eliminado",
				Text: "El punto de visita seleccionado se eliminó con éxito",
			},
		},
		VisitPointNotFound: {
			Title: "Punto de Visita no encontrado",
			Text1: "Registro de punto de visita con id:",
			Text2: "no encontrado.",
		},
	},
	Group: {
		Group: "Grupo",
		Groups: "Grupos",
		AddGroup: "Agregar grupo",
		CreateGroup: "Crear grupo",
		UpdateGroup: "Actualizar grupo",
		OptimizationGroup: "Grupo de optimización",
		OptimizationGroups: "Grupos de optimización",
		ListOfOptimizationGroups: "Lista grupos de optimización",
		TotalOptimizations: "No. Optimizaciones",
		TotalCreated: "Total Creado",
		TotalProcessed: "Total Procesados",
		TotalFinalized: "Total Finalizado",
		TotalErrors: "Total Errores",
		OptimizationsByGroup: "Optimizaciones por grupo",
		Messages: {
			Delete: "¿Estás seguro de eliminar la capacidad? Por favor acepta para continuar",
			TitleConfirmDelete: "Grupo Eliminado",
			TextConfirmDelete: "El grupo seleccionado ha sido eliminado.",
			TitleConfirmCreate: "Grupo Creado",
			TextConfirmCreate: "El grupo fue creado exitosamente",
			TitleConfirmUpdate: "Grupo Actualizado",
			TextConfirmUpdate: "El grupo fue actualizado correctamente",
			DeleteAll: "¿Está seguro de eliminar todos los grupos de la tabla?",
		},
		DeleteGroup: {
			Text1: "¿Estas seguro de eliminar el grupo",
			Text2: "Por favor aceptar para continuar.",
		},
		CellRenderer: {
			DeleteRecord: "Está a punto de eliminar",
			DeleteSuccess: {
				Title: "Grupo eliminado",
				Text: "El grupo seleccionado fue eliminado exitosamente",
			},
		},
	},
	Optimization: {
		Optimization: "Optimización",
		Optimizations: "Optimizaciones",
		CreateOptimization: "Crear optimización",
		ListOptimizations: "Listar optimizaciones",
		ListOfOptimizations: "Lista de optimizaciones",
		ConfigurePeriod: "Configurar período",
		AcceptsNumbersLettersAndTheDashSign:
			"Ingrese un formato válido para el nombre teniendo en cuenta que solo acepta números, letras y el signo guión",
		Distance: "Distancia",
		Fixed: "Fijado",
		Time: "Tiempo",
		TraveledHour: "Hora recorrida",
		VehicleTime: "Tiempo del vehículo",
		OptimizationPeriod: "Período de optimización",
		OptimizationHistory: "Historial de optimizaciones",
		TheProfileOfEachSelectedVehicle: "El perfil de cada vehículo seleccionado",
		OptimizationsCreated: "Optimizaciones creadas",
		OptimizationsFinished: "Optimizaciones finalizadas",
		OptimizationsInProgress: "Optimizaciones en curso",
		OptimizationsWithErrors: "Optimizaciones con errores",
		OptimizationsPerRouter: "Optimizaciones por ruteador",
		OptimizationsCompleted: "Optimizaciones completadas",
		OptimizationsCompletedByRouter: "Optimizaciones completadas por ruteador",
		OptimizationProfileVehicleText:
			"Revise los vehículos seleccionados para la optimización y asegúrese de que todos tienen el perfil adecuado antes de continuar. Si algún vehículo no tiene un perfil asignado, se aplicará automáticamente el perfil estándar de «carro».",
		ValidateOptimizationVisitpointText:
			"Para continuar es necesario tener añadidos un mínimo de dos puntos de visita.",
		ValidateOptimizationResourceText: "Para continuar, debes agregar al menos un recurso.",
		TheUploadedFilesAreTemporaryForOptimization:
			"Los archivos cargados son temporales para la optimizacion y se borrarán cuando cambies a la opción de información seleccionada",
		OnlyMaximizeOrMinimizeTourCountAllowed:
			"Solo se puede seleccionar maximizar o minimizar el número de tours pero no ambos al mismo tiempo.",
		DeleteOptimization: {
			Text1: "¿Estas seguro de eliminar la optimización",
			Text2: "Por favor aceptar para continuar.",
		},
		CellRenderer: {
			DeleteRecord: "Está a punto de eliminar",
			DeleteSuccess: {
				Title: "Optimización eliminada",
				Text: "La optimización seleccionada fue eliminada exitosamente",
			},
		},
		Messages: {
			"is not valid": "Estos no son datos válidos",
			"the longitude coordinate is out of bounds": "La coordenada de longitud está fuera de los límites",
			"the latitude coordinate is out of bounds": "La coordenada de latitud está fuera de los límites",
			"the longitude coordinate is not valid": "La coordenada de longitud no es válida",
			"the latitude coordinate is not valid": "La coordenada de latitud no es válida",
			"minimum time_service 00:00:00": "Tiempo mínimo_servicio 00:00:00",
			"Init hour window greater than end hour window": "Ventana de hora inicial mayor que ventana de hora final",
			"Init date/hour window outside of global window":
				"Ventana de fecha/hora de inicio fuera de la ventana global",
			"End date/hour window outside of global window":
				"Ventana de fecha/hora de finalización fuera de la ventana global",
			"Init hour window outside of global window": "Ventana de hora inicial fuera de la ventana global",
			"End hour window outside of global window": "Ventana de hora de finalización fuera de la ventana global",
			"Init date/hour break outside of vehicle time window":
				"Fecha/hora de inicio de descanso fuera de la ventana de tiempo del vehículo",
			"End date/hour break outside of vehicle time window":
				"Fecha/hora de finalización del descanso fuera de la ventana horaria del vehículo",
			enum: "El valor no coincide con ninguno de los valores permitidos en la lista",
			type: "El tipo del valor no coincide con el tipo especificado en el esquema de datos",
			required: "Se requiere una propiedad específica en los datos, pero está ausente",
			pattern: "El valor no cumple con el patrón necesario en el esquema de datos",
			format: "El valor no cumple con el formato especificado, como una dirección de correo electrónico, una URL, una fecha, etc",
			minimum: "El valor es menor que el valor mínimo permitido",
			maximum: "El valor es mayor que el valor máximo permitido",
			minLength: "La longitud del valor es menor que la longitud mínima permitida",
			maxLength: "La longitud del valor es mayor que la longitud máxima permitida",
			minItems: "La cantidad de elementos en una matriz es menor que la cantidad mínima permitida",
			maxItems: "La cantidad de elementos en una matriz es mayor que la cantidad máxima permitida",
			Unknown: "Ocurrió un error desconocido durante la optimizacion, inspeccione error.serverResponse",
		},
	},
	RoutingTypeSearch: "Tipo de ruteador",
	VValidateMessage: {
		"The name field is required": "El campo de nombre es obligatorio",
		"Please enter your Skill name here": "El campo es obligatorio",
		"Please enter your break name here": "El campo es obligatorio",
		"Please enter your company name here": "El campo es obligatorio",
		"The name field may not be greater than 50 characters":
			"El campo de nombre no puede tener más de 50 caracteres.",
		"The name field may not be greater than 125 characters":
			"El campo de nombre no puede tener más de 125 caracteres.",
		"The name field may not be greater than 128 characters":
			"El campo de nombre no puede tener más de 128 caracteres.",
		"The name field may not be greater than 150 characters":
			"El campo de nombre no puede tener más de 150 caracteres.",
		"The description field may not be greater than 150 characters":
			"El campo de descripción no puede tener más de 150 caracteres.",
		"The description field may not be greater than 250 characters":
			"El campo de descripción no puede tener más de 250 caracteres.",
		"Please enter name here": "Por favor, ingrese el nombre aquí",
	},
	TimeWindow: {
		TimeWindows: "Ventanas horarias",
		TimeWindow: "Ventana horaria",
		ListOfTimeWindows: "Lista de ventanas horarias",
		CreateTimeWindows: "Crear ventanas horarias",
		AddTimeWindows: "Agregar ventanas horarias",
		Duration: "Duración",
		Daily: "Diaria",
		Weekly: "Semanal",
		Monthly: "Mensual",
		Day: "Día",
		Month: "Mes",
		Week: "Semana",
		Hours: "Horas",
		Minutes: "Minutos",
		Minute: "Minuto",
		EveryDay: "Cada día",
		Every: "Cada",
		FromThe: "Apartir del",
		StartingAtMinute: "A partir del minuto",
		BetweenMinute: "Entre minuto",
		OfTheMonth: "Del mes",
		SpecificDayOfTheWeek: "Día específico de la semana (elija uno o varios)",
		Programming: "Programación",
		SpecificDayOfTheMonth: "Día específico del mes (elija uno o varios)",
		EveryMonth: "Cada mes",
		MonthsStartingAtMonth: "Mes(es) a partir del mes",
		SpecificMonth: "Mes específico (elegir uno o varios)",
		EveryMonthBetween: "Cada mes entre",
		And: "Y",
		EveryHour: "Cada hora",
		HourStartingAtHour: "Hora a partir de la hora",
		SpecificHour: "Hora específica (elegir una o varias)",
		EveryHourBetweenHour: "Cada hora entre horas",
		EveryMinute: "Cada minuto",
		MinuteStartingAtMinute: "Minuto a partir del minuto",
		SpecificMinute: "Minuto específico (elegir uno o varios)",
		EveryMinuteBetweenMinute: "Cada minuto entre minuto",
		DayOfMonth: "Dia del mes",
		DayOfWeek: "Día de la semana",
		EveryDayBetween: "Todos los días entre",
		TheChosenTimeIsNotValid: "El horario elegido no es válido",
		Schedule: "Cronograma",
		UpdateTimeWindow: "Actualizar ventana horaria",
		ViewTimeWindow: "Visualizar ventana horaria",
		AssignedTimeWindows: "Ventanas horarias Asignadas",
		AssignTimeWindows: "Asignar ventanas horarias",
		AssignTimeWindowTooltip: "Cargar el listado de ventanas horarias disponibles para continuar",
		DeleteAllTimeWindows: "Eliminar todas las ventanas horarias.",
		NoAssignedTimeWindows: "No hay ventanas horarias asignadas",
		DeleteAllText: "Estás a punto de eliminar todas las",
		SoftTimeWindow: "Ventanas horarias blandas",
		PenaltyForAnticipation: "Penalización por anticipación",
		PenaltyForLateness: "Penalización por tardanza",
		SelectTimeWindows: "Selecciona ventanas de tiempo...",
		TheSumOfTheInitialDurationAndTheFinalDuration:
			"La suma de la duración inicial y la duración final debe ser menor o igual a la duración total de la ventana horaria",
		PleaseCompleteThegeneralTimeWindow:
			"Por favor, complete primero los datos de la ventana horaria general antes de continuar.",
		ThisWillBeEliminatedSecondTimeWindow: "Esto se eliminará si añade una segunda ventana horaria",
		DateAndTimeMustBeWithinTheGeneral: "La fecha y hora deben estar dentro del rango de la ventana horaria general",
		RemoveAllOtherTimeWindowsToEnable:
			"Elimine todas las demás ventanas horarias para habilitar la configuración de una ventana horaria blanda.",
		ItIsNotPossibleToAddAnotherTimeWindow:
			"No es posible agregar otra ventana horaria mientras exista una ventana horaria blanda activa. Por favor, elimínala o edítala antes de continuar.",
		ThereAreCurrentlyNoTimeWindowsAvailable:
			"Actualmente no hay ventanas horarias disponibles en la plataforma. Agrega una nueva utilizando la opción",
		AllDataRequestedAddedTimewindowAreRequired:
			"Todos los datos solicitados en la ventana horaria añadida son requeridos para continuar",
		NameMonth: {
			January: "Enero",
			February: "Febrero",
			March: "Marzo",
			April: "Abril",
			May: "Mayo",
			June: "Junio",
			July: "Julio",
			August: "Agosto",
			September: "Septiembre",
			October: "Octubre",
			November: "Noviembre",
			December: "Diciembre",
		},
		NameWeek: {
			Monday: "Lunes",
			Tuesday: "Martes",
			Wednesday: "Miércoles",
			Thursday: "Jueves",
			Friday: "Viernes",
			Saturday: "Sábado",
			Sunday: "Domingo",
		},
		DeleteTimeWindow: {
			Text1: "¿Estas seguro de eliminar la ventana horaria",
			Text2: "Por favor aceptar para continuar.",
		},
		CellRenderer: {
			DeleteRecord: "Está a punto de eliminar",
			DeleteSuccess: {
				Title: "Ventana horaria eliminada",
				Text: "La ventana horaria seleccionada fue eliminada exitosamente",
			},
		},
		Messages: {
			TitleConfirmCreate: "Ventana horaria Creada",
			TextConfirmCreate: "La ventana horaria fue creada exitosamente",
			TitleConfirmUpdate: "Ventana horaria Actualizada",
			TextConfirmUpdate: "La ventana horaria fue actualizada correctamente",
		},
		TimeWindowNotFound: {
			Title: "Ventana horaria no encontrada",
			Text1: "Registro de ventana horaria con id:",
			Text2: "no encontrado.",
		},
	},
	DesignConfig: {
		TypeField: "Tipo de Campo",
		MinimumCharacterLength: "Longitud mínima de caracteres",
		MaximumCharacterLength: "Longitud máxima de caracteres",
		MinimumVal: "Valor mínimo",
		MaximumVal: "Valor máximo",
		Option: "Opción",
		SwitchTitle: "Alternar Activo / Inactivo",
		SelectMinimumOneOption: "Seleccionar mínimo una opción",
		LoadOptions: "Cargar lista de opciones",
		CalendarStatus: "Estados del calendario",
		AllowValues: "Esta propiedad puede recibir uno de los siguientes valores",
		Date: "Fecha",
		DateTime: "Hora",
		Text: "Texto",
		Number: "Número",
		Email: "Correo electrónico",
		Select: "Selección",
		Url: "Url",
		File: "Archivo",
		Image: "Imagen",
		Coordinates: "Coordenadas",
		DefaultLocation: "Localización por defecto",
		Radio: "Varias opciones",
		Checkbox: "Casillas",
		Dropdown: "Desplegable",
		Switch: "Booleano",
		Composed: "Compuesta",
		MultipleChoice: "Selección multiple",
		TypeConfig: "Tipo de configuración",
		NewTypeConfig: "Nuevo Tipo de Configuración",
		NewTypeConfigRequired: "Tipo de Configuración Requerida",
		UpdateTypeConfig: "Actualizar Tipo de Configuración",
		ListOfTypeConfig: "Lista de Tipos de Configuración",
		InputNameTypeConfig: "Nombre del tipo",
		ButtonAddTypeConfig: "Añadir",
		TitleConfirmTypeConfigUpdate: "Tipo de configuración modificada",
		TextConfirmTypeConfigUpdate: "El tipo de configuración seleccionada fue modificada exitosamente",
		TypeConfigCrudFormTitleCreate: "Formulario para crear un tipo de configuración",
		TypeConfigCrudFormTitleEdit: "Formulario para editar un tipo de configuración",
		TitleSuccessTypeConfigCreated: "Tipo Configuración creada",
		TextSuccessTypeConfigCreated: "El tipo de configuración se creó correctamente",
		TitleSuccessTypeConfigCreatedError: "Error al crear el tipo de configuración",
		TextSuccessTypeConfigCreatedError: "El tipo de configuración no ha sido creado",
		DeleteTypeConf: "¿Está seguro de eliminar este tipo de configuración?",
		TypeConfigConfigName: "Nombre Tipo de Configuración",
		TypeConfigStatus: "Estado",
		TypeConfigAddDateOn: "Añadido",
		Property: "Propiedad",
		ChangeName: "Cambiar nombre",
		DeleteField: {
			Text1: "¿Estas seguro de eliminar el campo",
			Text2: "Por favor aceptar para continuar.",
		},
		UserDeleted: {
			Title: "Usuario eliminado",
			Text: "El usuario seleccionado se eliminó con éxito.",
		},
	},
	Setting: {
		Setting: "Configuración",
		NewConfiguration: "Nueva Configuración",
		VisualSetting: "Ajustes Visuales",
		ThemeColor: "Color del Tema",
		NavbarColor: "Color Barra de Navegación",
		ConfirmSave: "¿Desea guardar los cambios aplicados?",
		Saved: "Cambios guardados exitosamente",
		SelectCompany: "Seleccione la empresa a configurar",
		AllowedLogo: "Permitidos archivos JPG y PNG. Con tamaño máximo de 900kB",
		ImageNotAllowed: "Imagen no permitida",
		ChooseImage: "Elegir Imagen",
		UploadImage: "Cargar Imagen",
		DeleteImage: "¿Estás seguro de eliminar la imagen?",
		ImagenUploaded: "La imagen se cargó correctamente",
		ValidatorRequiredProperty: "Es una propiedad requerida",
		TooShortProperties: "Valor de la propiedad esta vacio o el contenido es demasiado corto",
		IsNotStringValid: "No es una cadena de texto válida",
		IsGreaterThanMaximum: "Es mayor que el valor máximo permitido",
		IsLessThanMinimum: "Es menor que el valor mínimo permitido",
		ReviewValues: "Revisa los valores permitidos en el módulo de tipos de configuración",
		IsTooLong: "La cadena de texto es demasiado larga",
		UnexpectedError: "Ocurrió un error inesperado",
	},
	SessionApi: {
		SessionApi: "Sesión por API",
		AccessToken: "Token de acceso",
		ExpireDate: "Fecha de expiración",
		ExpireDateError: "La fecha de expiración del token no puede ser mayor a la fecha de operación de la empresa",
		GenerateAccessToken: "Crear nuevo token de acceso por API",
		NotFoundAccessToken: "La empresa no tiene token de accesos por API",
		Copy: "Copiar",
		Copied: "Copiado",
		CopiedText: "Token copiado al portapapeles con éxito",
		Messages: {
			TitleConfirmCreate: "Token creado",
			TextConfirmCreate: "El Token fue creado exitosamente",
			TitleConfirmDelete: "Token Eliminado",
			TextConfirmDelete: "El Token seleccionado fue eliminado exitosamente",
			TitleConfirmUpdate: "Token Actualizado",
			TextConfirmUpdate: "El Token seleccionado fue actualizado exitosamente",
			DepositNotFound: "Token no encontrado",
		},
	},
	ErrorVariable: {
		Textvariable1: "Campo incorrecto o vacio!",
	},
	Preferences: {
		Preferences: "Preferencias",
		ListOfPreferences: "Lista de preferencias",
		FilterSearchTitle: "Tipo de busquedas",
		FilterSearchNote: "Sólo funciona cuando la búsqueda es a través de los campos adicionales",
		FilterSearchText:
			"Permite establecer si la búsqueda de puntos de visita o recursos es estrictamente iguales a los criterios especificados o si la búsqueda tiene en cuanta las coincidencias",
		FindExactly: "Buscar por criterio exacto",
		FindCoincidence: "Buscar por coincidencia",
		NumberDays: "Número de dias",
		NotificationNumberDays:
			"Configurar el número de días previos desde los cuales la plataforma cargará y mostrará notificaciones",
		NotificationNumber:
			"Configurar la cantidad máxima de notificaciones que puede mostrarse desde la última notificación recibida",
		DeleteOldNotification:
			"Al iniciar la plataforma, eliminar automáticamente las notificaciones más antiguas a los días previos establecidos anteriormente",
		FilterSearchExactText:
			"Activar la búsqueda por criterio exacto establece que la búsqueda en la lista sea estrictamente igual a los criterios especificados",
		AllowsFindExactly:
			"Permite establecer si la búsqueda de los módulos seleccionados es estrictamente igual a los criterios especificados",
	},
	ManualData: {
		Required: "Requerida",
		InformationFound: "Información encontrada",
		ErrorsFound: "Errores encontrados en el cargue de información.",
		ErrorsNotFound: "Ningún error encontrado durante el proceso de carga de información.",
		ValidatorRequiredProperty: "Es una propiedad requerida",
		AlreadyRegistered: "Ya registrado(a)",
		DateLessThanCurrentDate: "La fecha debe ser mayor a la fecha actual",
		NotRegistered: "No registrada en el sistema",
		ValidatorAdditionalProperties: "Propiedad adicional no permitida, por favor eliminela",
		TooShortProperties: "Valor de la propiedad esta vacio o el contenido es demasiado corto",
		country: "Pa\u00EDs",
		city: "Ciudad",
		address: "Direcci\u00F3n",
		identification: "Identificaci\u00F3n",
		phone: "Tel\u00E9fono",
		name: "Nombre",
		cx: "CX",
		cy: "CY",
		date: "Fecha",
		ManageError: "Administrar Errores",
		ProcessAgain: "Procesar Nuevamente",
		ProcessAgainText:
			"Procesar nuevamente el archivo; esto intentará crear nuevos registros en el sistema, así que tenga en cuenta que los registros no deben existir.",
		ProcessAgainTextSuccess:
			"Reprocesar el archivo está funcionando en segundo plano, verifique o espere las notificaciones del sistema para conocer el estado del proceso.",
		DownloadFile: "Descargar Archivo",
		Download: "Descargar",
		AddedOn: "Añadido",
		PropertyError: "Error en la propiedad",
		ShowErrors: "Mostrar errores",
		FixErrorsHere: "Corregir errores aquí",
		FixErrorsModule: "Solucionar errores en módulo",
		SaveChanges: "Guardar Cambios",
		ActivityNotRegistered: "Actividad no registrada",
		EditAlertText:
			"Edite la propiedad seleccionada, respete el formato de esta y tenga en cuenta que algunos valores deben existir.",
		Property: "Propiedad",
		ResourceHasNoActivities: "Recurso no tiene ninguna actividad asignada",
		SaveRecordError: "Error guardando el registro",
		DaneCodeNotFound: "Código dane no encontrado",
		DuplicateRecordInExcel: "Registro duplicado en el excel",
		InitHourLessThanCurrentTime: "La hora inial no puede ser menor que la hora actual.",
		ErrorEndHour: "Error en la hora final",
		ErrorInitHour: "Error en la hora inicial",
		ErrorDate: "Error en la fecha",
		CoordinatesCouldBeNotFound: "Coordenadas no pudieron ser encontradas",
		AddressCouldBeNotGeoreferenced: "La dirección no pudo ser georreferenciada",
		TimeDataFormat:
			"El formato no es válido, el formato correcto debe ser similar para fechas AAAA-mm-dd o para horas HH:mm:ss",
		SitidataGeoreverseToken: "El token georeverse de Sitidata api no está habilitado para este pais",
		InvalidValue: "tiene un valor no valido, solo se permite cadena de caracteres",
	},
	OptimizerManager: {
		ManageOptimizers: "Administrar optimizadores",
		CreateConfiguration: "Crear configuración",
		UpdateConfiguration: "Actualizar configuración",
		PointsPerDay: "Puntos por día",
		PointsPerMonth: "Puntos por mes",
		PointsPerWeek: "Puntos por semana",
		PointsTotal: "Total de puntos",
		PointsSubscriptionMonthly: "Puntos por suscripción mensual",
		EnableOptimizationByTheWebPlatform: "Habilitar optimización por la plataforma web",
		EnableOptimizationByAPIConsumption: "Habilitar optimización por consumo de API",
		CreateOptimizerConfiguration: "Crear configuración del optimizador",
		Optimizers: "Optimizadores",
		OptimizerConfigurationList: "Lista de configuración de optimizadores",
		optimizerCompanyRequiredText:
			"La empresa requiere la configuración de un optimizador de rutas específico, pongase en contacto con el administrador de la plataforma para realizar la configuración",
		DeleteOptimizerManager: {
			Text1: "¿Está seguro de eliminar la configuración con Id",
			Text2: "Por favor, acepte para continuar.",
		},
		CellRenderer: {
			DeleteRecord: "Está a punto de eliminar",
			DeleteSuccess: {
				Title: "Configuración eliminada",
				Text: "La configuración seleccionada se ha eliminado correctamente",
			},
		},
		Success: {
			Title: "Configuración del optimizador creada",
			Text: "Configuración del optimizador creada exitosamente",
		},
		EditSuccess: {
			Title: "Configuración del optimizador actualizada",
			Text: "Configuración del optimizador se actualizó correctamente",
		},
		ErrorMessage: {
			TheOptimizationApiAlreadyExistsForTheEnterprise: "La api de optimización ya existe para la empresa",
			ApiKeyIsNotRequiredForThisOptimizationApi: "La clave api no es necesaria para esta api de optimización",
			NotAValidDate: "No es una fecha válida",
			DateLessThanCurrentDate: "Fecha inferior a la fecha actual",
			ThePointsperdayFieldMustBe2147483647OrLess: "El campo puntos por día debe ser 2147483647 o inferior",
			ThePointsPerWeekFieldShouldBe2147483647OrLower: "El campo puntos por semana debe ser 2147483647 o inferior",
			ThePointsPerMonthFieldMustBe2147483647OrLower: "El campo puntos por mes debe ser 2147483647 o inferior",
			TheTotalPointsFieldMustBe2147483647OrLower: "El campo puntos totales debe ser 2147483647 o menos",
			ThePointsSubscriptionMonthlyFieldMustBe2147483647OrLess:
				"El campo puntos suscripción mensual debe ser 2147483647 o menos",
			TheTotalPointsFieldMustBe4294967295OrLower: "El valor ingresado debe ser 4294967295 o inferior",
		},
	},
	Vehicles: {
		Vehicle: "Vehículo",
		Vehicles: "Vehículos",
		CreateVehicle: "Crear vehículo",
		UpdateVehicle: "Actualizar vehículo",
		YouAreAboutToDeleteTheVehicle: "Está a punto de eliminar el registro con identificación",
		AllVehicles: "Todos los vehículos",
		ViewVehicles: "Visualizar vehículo",
		ListOfVehicles: "Lista de Vehículos",
		AssignVehicles: "Asignar vehículos",
		AssignedVehicle: "Vehículo Asignado",
		AssignedVehicles: "Vehículos Asignados",
		NoAssignedVehicles: "No hay vehículos asignados",
		AssigneVehicleText: "Seleccione los vehículos que desea asignar.",
		AssignVehicleToltip: "Cargar el listado de vehículos disponibles para continuar",
		AssignAllVehicleText: "Asignar todos vehículos de la plataforma",
		DeleteAllVehicles: "Eliminar todos vehículos",
		DeleteAllText: "Estás a punto de borrar todos los",
		SelectedPointsOf: "Vehículos Seleccionados de",
		SelectedPointOf: "Vehículo Seleccionado de",
		ShowOnlySelectedVehicles: "Mostrar sólo los vehículos seleccionados",
		VehiclesPointsSelected: "Vehículos seleccionados",
		Service: "Servicio",
		ImportResourcesToVehicles: "Importar recursos a vehículos",
		ImportResources: "Importar recursos",
		ExportResourcesToVehicles: "Exportar recursos a vehículos",
		PermittedVehicles: "Vehículos permitidos",
		CostPerVehicle: "Costo por vehículo",
		CurrentlyThereAreNoVehiclesInTheSystem:
			"Actualmente no hay vehículos creados. Agrega uno nuevo utilizando la opción disponible",
		ThisListOnlyShowsSupervisoryAndExecutive:
			"Recursos de rol supervisor y ejecutivos que no están en el módulo de vehículos",
		Success: {
			Title: "Vehículo creado",
			Text: "Vehículo creado exitosamente",
		},
		EditSuccess: {
			Title: "Vehículo actualizado",
			Text: "El vehículo se actualizó correctamente",
		},
		CellRenderer: {
			DeleteRecord: "Está a punto de eliminar",
			DeleteSuccess: {
				Title: "Vehículo eliminado",
				Text: "El vehículo seleccionado se eliminó con éxito",
			},
		},
		VehicletNotFound: {
			Title: "Vehículo no encontrado",
			Text1: "Registro de Vehículo con id:",
			Text2: "no encontrado.",
		},
	},
	Record: {
		ListRecord: "Lista Registro",
		RecordNumber: "Registro Número",
		UpdateRecord: "Actualizar Registro",
		CreateRecord: "Crear Registro",
		DeleteRecord: "Eliminar Registro",
		DeleteRecordConfirmText: "¿Esta seguro de eliminar el registro del sistema?",
		TitleConfirmRecordCreate: "Registro creado",
		TextConfirmRecordCreate: "El registro fue creado exitosamente",
		TitleConfirmRecordDelete: "Registro Eliminado",
		TextConfirmRecordDelete: "El registro seleccionado fue eliminado exitosamente",
		TitleConfirmRecordUpdate: "Registro Actualizado",
		TextConfirmRecordUpdate: "El registro seleccionado fue actualizado exitosamente",
	},
	Frequency: {
		Frequency: "Frecuencia",
		Frequencies: "Frecuencias",
		ListOfFrequencies: "Lista de frecuencias",
		CreateFrequencies: "Crear frecuencias",
		AddFrequencies: "Agregar frecuencias",
		UpdateFrequency: "Actualizar frecuencia",
		ViewFrequency: "Visualizar frecuencia",
		AssignedFrequencies: "Frecuencias Asignadas",
		AssignFrequencies: "Asignar frecuencias",
		AssignFrequencyTooltip: "Cargar el listado de frecuencias disponibles para continuar",
		DeleteAllFrequencies: "Eliminar todas las frecuencias.",
		NoAssignedFrequencies: "No hay frecuencias asignadas",
		ThereAreCurrentlyNoFrequenciesAvailable:
			"Actualmente no hay frecuenccias disponibles en la plataforma. Agrega una nueva utilizando la opción",
		DiscardedItems: {
			Title: "Elementos Descartados Debido a Frecuencias",
			Message: "Los siguientes elementos han sido descartados debido a conflictos de frecuencia:",
			Close: "Cerrar",
			Pickup: "Recogida",
			Delivery: "Entrega",
			Vehicle: "Vehículo",
			DiscardedDueToFrequencies: "descartado debido a frecuencias.",
			Showing: "Mostrando",
			of: "de",
			items: "elementos",
		},
		Messages: {
			TitleConfirmCreate: "Frecuencia Creada",
			TextConfirmCreate: "La frecuencia fue creada exitosamente",
			TitleConfirmUpdate: "Frecuencia Actualizada",
			TextConfirmUpdate: "La frecuencia fue actualizada correctamente",
		},
		DeleteFrequency: {
			Text1: "¿Estas seguro de eliminar la frecuencia",
			Text2: "Por favor aceptar para continuar.",
		},
		CellRenderer: {
			DeleteRecord: "Está a punto de eliminar",
			DeleteSuccess: {
				Title: "Frecuencia eliminada",
				Text: "La frecuencia seleccionada fue eliminada exitosamente",
			},
		},
		FrequencyNotFound: {
			Title: "Frecuencia no encontrada",
			Text1: "Registro de frecuencia con id:",
			Text2: "no encontrado.",
		},
	},
	Jobs: {
		CreateJobPlanning: "Crear planificación de trabajos",
		SelectedJobs: "Trabajos seleccionados",
		JobPlanning: "Planificación de Trabajos",
		MaximumPickupDeliveryTime: "Duración Máxima Recogida-Entrega",
		MaximumTimeOfAbsoluteDeviation: "Tiempo Máximo de Desvío Absoluto",
		RelativeDeviationLimit: "Límite de Desvío Relativo",
		PenaltyCost: "Costo de penalización",
		ThisJobCannotBeAdded: "No se puede agregar este trabajo, porque ya existe uno con el mismo nombre",
		SpecifiesTheMaximumDuration:
			"Especifica la duración máxima desde el inicio de la recogida hasta el inicio de la entrega de un trabajo.",
		SpecifiesTheMaximumAbsolute:
			"Especifica el tiempo máximo de desvío absoluto en comparación con la ruta más corta desde la recogida hasta la entrega.",
		ToProceedYouMustAddAtLeast:
			"Para continuar, es necesario añadir al menos un punto de visita en los servicios de recogida y entrega",
		JobsAreUsedToAssociateADeliveryWithAPickup:
			"Los trabajos se utilizan para asociar una entrega a una recogida. Esto permite que el mismo vehículo se encargue de ambas tareas, optimizando rutas y recursos. Aunque es posible asignar más de una entrega o recogida a un mismo trabajo, esta flexibilidad permite al optimizador elegir la mejor opción para realizar la recogida y/o la entrega. Sin embargo, en el resultado final, cada trabajo estará configurado para gestionar sólo una recogida y una entrega.",
		AddJobsByFileUpload: "Agregar trabajos",
		JobsWereSuccessfullyAdded: "Los trabajos se agregaron correctamente",
		AllowedJobFiles: "Archivos de trabajos permitidos",
		UploadedJobFile: "Archivo cargado",
		MaximumFileSelectionForJobs: "Se alcanzó el máximo de archivos permitidos para trabajos",
		CostPerVehicle: "Costo por vehículo",
		CostPerVehicleColumnsRequired: "Debe seleccionar las columnas de identificación del vehículo y costo",
		DownloadTemplate: "Descargar plantilla XLSX",
		TemplateFileName: "plantilla_trabajos.xlsx",
		TemplateDownloadSuccess: "La plantilla de trabajos se descargó correctamente",
	},
	Territories: {
		Territories: "Territorios",
		Territory: "Territorio",
		TerritoryID: "ID de Territorio",
		TerritorySubtitle:
			"Visualiza en el mapa los territorios asignados a tus rutas. Cada territorio se representa con un polígono de color que delimita su área de cobertura y agrupa los puntos de visita asociados. Esta funcionalidad te permite identificar fácilmente la distribución de tus puntos en campo.",
		VisualizeTerritoriesOnTheMap: "Visualizar territorios en el mapa",
		ViewTerritories: "Ver Territorios",
		AllowOperationsOutsideTheAssignedArea: "Permitir operaciones fuera de la zona asignada",
		TerritoryDoesNotHaveEnough:
			"El territorio {n} necesita tres o más puntos de visita para poder armar un polígono en el mapa.",
	},
	AdvancedObjectives: {
		Objectives: "Objetivos",
		AdvancedObjectives: "Objetivos Avanzados",
		AdvancedObjectivesDescription:
			"Los objetivos avanzados proporcionan estrategias de optimización sofisticadas que van más allá de los objetivos básicos. Estos objetivos se pueden combinar para crear escenarios de optimización complejos adaptados a las necesidades específicas de cada negocio.",
		AdvancedObjectivesSaved: "Los objetivos avanzados se han guardado correctamente",
		ConfigureAdvancedObjectives: "Configurar objetivos avanzados",
		AddObjective: "Agregar objetivo",
		Objective: "Objetivo",
		ObjectiveType: "Tipo de objetivo",
		Configuration: "Configuración",
		SelectObjectiveType: "Seleccionar tipo de objetivo",
		SelectObjective: "Seleccionar objetivo",
		NoAdvancedObjectives: "No hay objetivos avanzados",
		AddAdvancedObjectivesDescription: "Agrega objetivos avanzados para personalizar la optimización de tus rutas.",
		MinimizeUnassigned: "Minimizar asignaciones no realizadas",
		MinimizeUnassignedDescription: "Minimiza el número de puntos de visita no asignados.",
		EagerDelivery: "Entrega inmediata",
		EagerDeliveryDescription:
			"Se utiliza con el objetivo minimizar costos para configurar el comportamiento de entrega inmediata",
		EnableEagerDelivery: "Habilitar entrega inmediata",
		TieThreshold: "Umbral de indiferencia",
		ImprovementThreshold: "Umbral de mejora significativa",
		MinimizeTours: "Minimizar recorridos",
		MaximizeTours: "Maximizar recorridos",
		MinimizeToursDescription: "Minimizar el número de recorridos/rutas",
		MaximizeToursDescription: "Maximizar el número de recorridos/rutas",
		MinimizeCostDescription: "Minimizar el costo total de la solución",
		OptimizeTaskOrder: "Optimizar el orden de las tareas",
		OptimizeTaskOrderDescription: "Optimizar el orden de las tareas dentro de las rutas",
		MinimizeDistance: "Minimizar distancia",
		MinimizeDistanceDescription: "Minimizar la distancia total recorrida",
		MinimizeDuration: "Minimizar duración",
		MinimizeDurationDescription: "Minimizar la duración total de todas las rutas",
		BalanceMaxLoad: "Balancear carga máxima",
		BalanceMaxLoadDescription: "Distribuir de manera equilibrada la carga entre todos los vehículos",
		BalanceActivities: "Balancear actividades",
		BalanceActivitiesDescription: "Balancear el número de actividades entre los vehículos",
		BalanceDistance: "Balancear distancia",
		BalanceDistanceDescription: "Balancear la distancia recorrida entre los vehículos",
		BalanceDuration: "Balancear duración",
		BalanceDurationDescription: "Balancear la duración de las rutas entre los vehículos",
		MaximizePriorityJobs: "Maximizar trabajos de prioridad",
		MaximizePriorityJobsDescription: "Maximizar el número de trabajos de prioridad servidos",
		MaximizeTerritoryJobs: "Maximizar trabajos de territorio",
		MaximizeTerritoryJobsDescription: "Maximizar el número de trabajos de territorio servidos",
		TourOrder: "Orden de recorrido",
		TourOrderDescription: "Optimizar el orden de las visitas",
		OptimizeTaskPosition: "Optimizar posición de tareas",
		OptimizeTaskPositionDescription: "Optimizar la posición de las tareas dentro de los recorridos",
		VisuallyAppealingTours: "Visitas visualmente atractivas",
		VisuallyAppealingToursDescription: "Crea formas de recorrido visualmente atractivas",
		MinimizeTourOverlap: "Minimizar superposición de recorridos",
		MinimizeTourOverlapDescription: "Minimizar la superposición entre diferentes recorridos",
		ServeInClusters: "Servir en clusters",
		ServeInClustersDescription: "Atender puntos de visita en agrupaciones geográficas.",
		TieBreak: "Criterio de desempate",
		TieBreakDescription: "Resolver empates entre múltiples objetivos",
		Threshold: "Umbral",
		BalanceThresholdDescription: "Umbral para la optimización del equilibrio",
		Weight: "Peso",
		WeightDescription: "Peso para la optimización del equilibrio",
		IsConstrained: "Restringir",
		IsConstrainedDescription: "Restringir el objetivo a ser solucionado por un solo objetivo",
		Tolerance: "Tolerancia",
		ToleranceDescription: "Tolerancia para la optimización del objetivo",
		MaxClusterRadius: "Radio máximo de cluster",
		MaxClusterRadiusDescription: "Radio máximo de cluster para la optimización del objetivo",
		TieBreakRules: "Reglas de desempate",
		TieBreakRulesDescription: "Reglas de desempate para la optimización del objetivo",
		ValidationError: "Error de validación",
		AtLeastOneAdvancedObjectiveRequired: "Al menos un objetivo avanzado es requerido",
		AllObjectivesMustHaveType: "Todos los objetivos deben tener un tipo seleccionado",
		TieBreakMustHaveRules: "El objetivo de desempate debe tener al menos una regla",
		TieBreakRulesMustHaveObjective: "Las reglas de desempate deben tener un objetivo seleccionado",
	},
	FieldDescriptions: {
		identification: "Identificador único para cada registro",
		longitude: "Coordenada de longitud (formato decimal)",
		latitude: "Coordenada de latitud (formato decimal)",
		priority: "Nivel de prioridad (número)",
		time_service: "Tiempo de servicio en minutos",
		skills: "Habilidades requeridas (separadas por comas)",
		demand: "Demanda o capacidad requerida",
		allowed_vehicles: "Vehículos permitidos",
		time_window: "Ventanas de tiempo disponibles",
		additional_info: "Información adicional",
		territory_id: "ID del territorio",
		profile: "Perfil del vehículo",
		max_travel_distance: "Distancia máxima de viaje",
		max_travel_duration: "Duración máxima de viaje",
		init_depot: "Depósito inicial",
		end_depot: "Depósito final",
		capacity: "Capacidad del vehículo",
		breaks: "Descansos programados",
		time_cost: "Costo por tiempo",
		traveled_hour_cost: "Costo por hora viajada",
		distance_cost: "Costo por distancia",
		fixed_cost: "Costo fijo",
		strict_territories: "Territorios estrictos",
		territories: "Territorios asignados",
		original_identification: "Identificador para agrupar los registros",
		init_depot_id: "Coordenadas del depósito inicial",
		end_depot_id: "Coordenadas del depósito final",
		address: "Dirección",
		country: "País",
		status: "Estado",
		department: "Departamento",
		city: "Ciudad",
	},
	FieldHints: {
		identification: "Ejemplo: ID_001, VEH_001",
		longitude: "Ejemplo: -74.0059",
		latitude: "Ejemplo: 4.7110",
		priority: "Valores: 1 (alta) a 5 (baja)",
		time_service: "En minutos, ejemplo: 30",
		skills: "Ejemplo: refrigerado, pesado",
		demand: "Ejemplo: 100, 2.5",
		time_window: "Horarios de atención",
		select_multiple: "Selecciona columnas para {key}...",
		select_single: "Selecciona columna para {key}...",
	},
	FiltersAdvanced: {
		Title: "Panel de Filtros",
		BasicMode: "Básico",
		AdvancedMode: "Avanzado",
		BasicModeTitle: "Filtros Básicos",
		BasicModeDescription: "Búsqueda simple por campo y valor",
		AdvancedModeTitle: "Filtros Avanzados",
		AdvancedModeDescription: "Filtros múltiples con operadores lógicos y ordenamiento",
		SearchBy: "Buscar por:",
		SelectField: "Seleccionar campo...",
		EnterValue: "Ingresa un valor...",
		Search: "Buscar",
		ClearFilters: "Eliminar Filtros",
		FieldSelection: "Selección de Campo",
		SelectFilterToAdd: "Seleccionar filtro...",
		Add: "Agregar",
		Clear: "Limpiar",
		ActiveFilters: "Filtros Activos",
		AddValue: "Agregar valor...",
		NoFiltersAdded: "No hay filtros agregados",
		SelectFieldAbove: "Selecciona un campo arriba para comenzar",
		FilterConfiguration: "Configuración de Filtros",
		LogicalOperator: "Operador Lógico",
		AND: "Y (AND)",
		OR: "O (OR)",
		MatchType: "Tipo de Coincidencia",
		PartialMatch: "Coincidencia Parcial",
		ExactMatch: "Coincidencia Exacta",
		Sorting: "Ordenamiento",
		ApplyFilters: "Aplicar Filtros",
		Searching: "Buscando",
		SearchSuccess: "Búsqueda realizada con éxito",
		SearchError: "Error al realizar la búsqueda",
		InvalidFilters: "Por favor completa todos los campos de los filtros",
		GroupPlaceholder: "Grupo (opcional)",
		NoGroup: "Sin grupo",
		AndGroup: "Grupo AND",
		OrGroup: "Grupo OR",
	},

	Wizard: {
		// General
		Previous: "Anterior",
		Next: "Siguiente",
		Generate: "Generar Clustering",
		Close: "Cerrar",
		Finish: "Finalizar",
		StepIndicator: "Paso {current} de {total}",
		ValidationError: "Por favor completa todos los campos requeridos",
		Generating: "Generando Clustering...",
		GeneratingMessage: "Por favor espera mientras procesamos tu clustering. Esto puede tomar unos momentos.",
		GenerateError: "Error al generar clustering",
		ConfirmCancel: "¿Estás seguro de que deseas cancelar? Se perderá todo el progreso.",
		Minimize: "Minimizar",
		Minimized: "Wizard minimizado. Puedes continuar interactuando con el mapa.",
		RestoreWizard: "Restaurar Wizard",
		ContinueCreating: "Continuar creando",
		SelectionComponentNotFound:
			"No se pudo acceder al componente de selección. Intenta cerrar y abrir el wizard nuevamente.",

		// Common
		Recommended: "Recomendado",
		Easy: "Fácil",
		Optional: "Opcional",
		Available: "Disponibles",
		Selected: "Seleccionados",
		Loading: "Cargando",
		Success: "Éxito",
		Instant: "Instantáneo",
		PointsAvailable: "puntos disponibles",
		AdvancedFilters: "Filtros avanzados",
		PreciseControl: "Control preciso",
		LoadAndContinue: "Cargar y Continuar",
		ConfigureFilters: "Configurar Filtros",
		ShowPreview: "Ver Vista Previa",
		HidePreview: "Ocultar Vista Previa",
		ReloadPoints: "Recargar Puntos",
		PointsPreview: "Vista Previa de Puntos",
		ShowingFirst: "Mostrando los primeros {count}",
		Of: "de",
		SearchByName: "Buscar por nombre",
		SearchPoints: "Buscar puntos...",
		Show: "Mostrar",
		Hide: "Ocultar",
		SelectFiltered: "Seleccionar Filtrados",
		ClearSelection: "Limpiar Selección",
		StartDrawing: "Iniciar Dibujo",
		FinishDrawing: "Terminar Dibujo",
		UndoLast: "Deshacer Último",
		ClearAll: "Limpiar Todo",
		PolygonsDrawn: "polígonos dibujados",
		PolygonRemoved: "Polígono Eliminado",
		LastPolygonRemoved: "El último polígono fue eliminado",
		ConfirmClearAllPolygons: "¿Eliminar todos los polígonos? Los puntos se deseleccionarán.",
		AllPolygonsCleared: "Polígonos Eliminados",
		PointsDeselected: "Todos los puntos fueron deseleccionados",
		ConfirmCreateAnother: "¿Deseas crear un nuevo clustering? Se perderán los datos actuales del wizard.",
		CreatingNew: "Iniciando nuevo wizard de clustering",
		ClickToAdd: "Haz clic para agregar",
		ClickToRemove: "Haz clic para quitar",
		SelectedPointsSummary: "Resumen de Puntos Seleccionados",
		PolygonDrawingFinished: "{count} puntos seleccionados con polígonos",
		SelectAll: "Seleccionar Todos",
		DeselectAll: "Deseleccionar Todos",
		PointsSelected: "Puntos seleccionados",
		SelectionSummary: "Resumen de Selección",
		EstimatedResult: "Resultado Estimado",
		PointsPerCluster: "Puntos por cluster",
		MicroClustersPerCluster: "Micro-clusters por cluster",
		DemandPerCluster: "Demanda por cluster",
		ShowingItems: "Mostrando {from}-{to} de {total}",

		// Steps
		Steps: {
			Origin: {
				Title: "Origen de Datos",
				Subtitle: "Cargar puntos de visita",
				MainTitle: "¿De dónde vienen tus puntos de visita?",
				Description: "Elige cómo deseas cargar los puntos que usarás para el clustering",
				LoadAll: "Cargar Todos los Puntos",
				LoadAllDesc:
					"Opción rápida: carga automáticamente todos los puntos de visita disponibles en el sistema",
				FilterFirst: "Filtrar Antes de Cargar",
				FilterFirstDesc:
					"Opción avanzada: configura filtros específicos para cargar solo los puntos que necesitas",
				SkipLoad: "Seleccionar Puntos",
				SkipLoadDesc: "Acceder directamente a la tabla de puntos disponibles y seleccionar los que necesites",
				SelectFromTable: "Seleccionar desde tabla",
				OrCreateManually: "O crear manualmente",
				ContinueToSelection: "Continuar a Selección",
				SkipMessage: "Puedes seleccionar puntos desde la tabla o crearlos manualmente",
				PointsLoaded: "¡Puntos cargados exitosamente!",
				LoadedCount: "{count} puntos están listos para seleccionar",
				ConfigureFilters: "Configurar Filtros Avanzados",
				FilterHelp: "Usa estos filtros para cargar solo los puntos que cumplan con tus criterios",
				ConfirmReload: "¿Estás seguro de recargar los puntos? Esto eliminará tu selección actual.",
				LoadSuccess: "¡{count} puntos cargados exitosamente!",
				NoPoints: "No se encontraron puntos de visita",
				LoadError: "Error al cargar los puntos de visita",
			},
			Selection: {
				Title: "Selección",
				Subtitle: "Elegir puntos para clustering",
				MainTitle: "Selecciona los puntos que deseas agrupar",
				Description:
					"Usa el método que prefieras para seleccionar los puntos que formarán parte de tu clustering",
				MinimumRequired: "Mínimo {min} puntos requeridos",
				MinimumRequiredPoint: "Mínimo 1 punto requerido",
				FromTable: "Desde Tabla",
				CreatePoint: "Crear Punto",
				FromMap: "Desde Mapa",
				Quick: "Rápido",
				SelectFromTable: "Seleccionar desde la Tabla de Puntos",
				TableHelp:
					"Navega, busca y selecciona puntos directamente desde la tabla. Puedes marcar múltiples puntos a la vez.",
				CreateNewPoint: "Crear Nuevo Punto",
				CreateHelp:
					"Ingresa los datos manualmente para crear un nuevo punto de visita. El punto se agregará automáticamente al mapa y a tu selección.",
				AddAndSelect: "Agregar y Seleccionar",
				ClearForm: "Limpiar Formulario",
				PointsCreated: "Puntos Creados",
				PointCreated: "Punto creado y agregado exitosamente",
				PointRemoved: "Punto eliminado",
				NoID: "Sin ID",
				SelectFromMap: "Seleccionar desde el Mapa",
				MapHelp:
					"Usa herramientas de dibujo o haz clic directamente en los puntos del mapa para seleccionarlos",
				DrawPolygons: "Dibujar Polígonos",
				PolygonHelp: "Dibuja áreas en el mapa para seleccionar todos los puntos dentro de ellas",
				CreateByClick: "Crear Punto con Clic",
				CreateByClickHelp:
					"Haz clic en cualquier parte del mapa para crear un nuevo punto con esas coordenadas",
				StartClickCreate: "Activar Creación",
				StopClickCreate: "Detener Creación",
				ClickCreateModeActive: "Modo de creación activo. Haz clic en el mapa para crear un nuevo punto",
				EnterIdentification: "Identificación del Punto",
				EnterIdentificationHelp: "Ingresa la identificación para el nuevo punto",
				AddressFound: "Dirección encontrada",
				CoordinatesOnly: "No se pudo obtener dirección. Coordenadas",
				CreateCancelled: "Creación de punto cancelada",
				PointCreatedFromMap: "Punto '{identification}' creado desde el mapa",
				PointsCreatedByClick: "puntos creados",
				QuickSelection: "Selección Rápida",
				QuickHelp: "Selecciona o deselecciona todos los puntos con un solo clic",
				SelectAllHelp: "Selecciona automáticamente todos los puntos cargados",
				ClearHelp: "Elimina todos los puntos de la selección actual",
				FilteredSelected: "Puntos filtrados seleccionados exitosamente",
				AllSelected: "Todos los puntos han sido seleccionados",
			},
			Demand: {
				Title: "Demanda",
				Subtitle: "Configurar capacidades",
				MainTitle: "Configura la demanda de tus puntos",
				Description:
					"Asigna valores de demanda (capacidad requerida) a los puntos seleccionados. Este paso es opcional pero recomendado para un clustering más preciso.",
				Optional: "(Opcional pero recomendado)",
				QuickSetup: "Configuración Rápida",
				QuickHelp: "Aplica el mismo valor de demanda a todos los puntos seleccionados",
				IndividualEdit: "Edición Individual de Demandas",
			},
			Config: {
				Title: "Configuración",
				Subtitle: "Parámetros del clustering",
				MainTitle: "Configura tu clustering",
				Description: "Define el nombre y parámetros principales para generar el clustering",
				Parameters: "Parámetros del Clustering",
				NameHelp: "Elige un nombre descriptivo que te ayude a identificar este clustering",
				ClustersHelp: "Número de grupos principales que deseas crear (recomendado: 3-7)",
				ValidationError: "Por favor completa el nombre del clustering",
			},
			Result: {
				Title: "Resultado",
				Subtitle: "Clustering generado",
				Success: "¡Clustering Generado Exitosamente!",
				SuccessMessage: "Tu clustering ha sido creado y está listo para visualizar",
				NextSteps: "¿Qué deseas hacer ahora?",
				ActionsHelp: "Elige una acción para continuar trabajando con tu clustering",
				CreateAnother: "Crear Otro Clustering",
				InfoTitle: "💡 Información Útil",
				Info1: "Los colores en el mapa representan diferentes clusters",
				Info2: "Puedes visualizar clusters agrupados o micro-clusters individuales",
				Info3: "Los resultados se guardan automáticamente en tu lista de clusters",
			},
		},
	},

	Clustering: {
		Title: "Agrupación",
		Description: "Visualiza, crea y gestiona clusters de puntos de visita",
		ControlPanel: "Panel de Control",
		ClusterList: "Lista de Clusters",
		ClustersList: "Lista de Clusters",
		ClusterInfo: "Información del Cluster",
		MicroClusterInfo: "Información del Micro Cluster",
		ClusterSummary: "Resumen del Cluster",
		TotalDemand: "Demanda Total",
		AvgDemand: "Demanda Promedio",
		MicroClusterId: "ID del Micro Cluster",
		PointDetails: "Detalles del Punto",
		Statistics: "Estadísticas",
		TotalPoints: "Total de Puntos",
		BalanceMetrics: "Métricas de Equilibrio",
		BalanceAnalysis: "Análisis de Equilibrio",
		AverageDemand: "Demanda Promedio",
		StandardDeviation: "Desviación Estándar",
		VariationCoefficient: "Coeficiente de Variación",
		Deviation: "Desviación",
		GeneralConfig: "Configuración General",
		DetailedConfig: "Configuración Detallada",
		ClustersCreated: "Clusters Creados",
		MicroClusters: "Micro Clusters",
		MicroClustersPerCluster: "Micro Clusters por Cluster",
		Total: "Total",
		GeneratingConfig: "Generando Configuración",
		EnableCapacities: "Habilitar Capacidades",
		Enabled: "Habilitado",
		Disabled: "Deshabilitado",
		ExpandAll: "Expandir Todo",
		CollapseAll: "Contraer Todo",
		Of: "de",
		Balance: {
			Excellent: "Excelente",
			Good: "Bueno",
			Fair: "Regular",
			Poor: "Bajo",
		},
		NoStatsAvailable: "No hay estadísticas disponibles",
		ExportToExcel: "Exportar a Excel",
		ExportedSuccessfully: "Estadísticas exportadas correctamente",
		ExportError: "Error al exportar las estadísticas",
		NoDataToExport: "No hay datos para exportar",
		ExportingData: "Preparando exportación...",
		ViewingOnMap: "Mostrando clustering en el mapa",
		OpeningList: "Abriendo lista de clusterings",
		ZoomTo: "Hacer Zoom",
		FocusOn: "Enfocar",
		RemoveFocus: "Quitar Enfoque",
		FocusedOn: "Enfocado en",
		Showing: "Mostrando",
		ShowingAll: "Mostrando todos los clusters",
		Highlight: "Destacar",
		Highlighted: "Destacado",
		ShowAll: "Mostrar Todos",
		Points: "Puntos",
		EnableHeatmap: "Activar Mapa de Calor",
		DisableHeatmap: "Desactivar Mapa de Calor",
		HeatmapEnabled: "Mapa de calor de demanda activado",
		HeatmapDisabled: "Mapa de calor de demanda desactivado",
		NoPointsInCluster: "No se encontraron puntos en este cluster",
		ZoomedToCluster: "Vista ajustada al cluster",
		Compactness: "Compacidad",
		AvgRadius: "Radio Promedio",
		MaxDistance: "Distancia Máxima",
		Area: "Área",
		Legend: "Leyenda",
		PointTypes: "Tipos de Puntos",
		SelectedPoints: "Puntos Seleccionados",
		UnselectedPoints: "Puntos No Seleccionados",
		ClusteredPoints: "Puntos Agrupados",
		Layers: "Capas",
		ClusterPolygons: "Polígonos de Clusters",
		Heatmap: "Mapa de Calor",
		DemandIntensity: "Intensidad de Demanda",
		QuickActions: "Acciones Rápidas",
		ViewMode: "Modo de Visualización",
		ViewClusters: "Clusters",
		ViewMicroClusters: "Micro Clusters",
		ViewStatistics: "Ver Estadísticas",
		ViewModeChanged: "Modo de visualización cambiado",
		GroupedView: "Vista Agrupada",
		DetailedView: "Vista Detallada",
		ViewClustersTooltip: "Ver clusters agrupados con sus micro-clusters",
		ViewMicroClustersTooltip: "Ver cada micro-cluster individualmente",
		ViewOnMap: "Ver en el mapa",
		ViewClustersOnMap: "Ver en el mapa los clusters",
		ViewMicroClustersOnMap: "Ver en el mapa los micro clusters",
		ConfirmViewModeChange: "Confirmar Cambio de Modo",
		ViewModeChangeWarning:
			"Al cambiar el modo de visualización se limpiará el mapa y se cerrarán todas las ventanas. ¿Deseas continuar?",
		ViewModeChangedSuccessfully: "Modo de visualización cambiado exitosamente",
		CreatingCluster: "Creando Cluster",
		Processing: "Procesando",
		CreatingClusterMessageBackground:
			"Estamos creando tu clúster en segundo plano. Esto puede tardar unos minutos. Mientras tanto, puedes seguir usando la plataforma con normalidad.",
		// Points
		LoadedPoints: "Puntos Cargados",
		LoadPoints: "Cargar Puntos",
		LoadAllPoints: "Cargar Todos los Puntos",
		ManagePoints: "Gestionar Puntos",
		PointManagement: "Gestión de Puntos",
		CurrentPoints: "Puntos Actuales",
		Selected: "Seleccionados",
		SelectExisting: "Seleccionar Existentes",
		SelectAllVisible: "Seleccionar todos visibles",
		ClearSelection: "Limpiar Selección",
		ClearMap: "Limpiar Mapa",
		MapCleared: "Mapa limpiado exitosamente",
		AddPoints: "Agregar Puntos",
		PointAlreadyExists: "Este punto ya existe en la lista",
		NoPointsLoaded: "No hay puntos cargados. Usa 'Gestionar Puntos' o 'Cargar Todos los Puntos' para comenzar.",
		TooManyPoints: "Demasiados puntos (máximo 500). Por favor, filtra o selecciona menos puntos.",
		PointsLoaded: {
			Title: "Puntos Cargados",
			Text: "puntos cargados exitosamente",
		},
		NoPointsFound: {
			Title: "Sin Puntos",
			Text: "No se encontraron puntos de visita disponibles.",
		},
		ErrorLoadingPoints: "Error al cargar los puntos de visita",
		PointsSelected: {
			Title: "Puntos Seleccionados",
			Text: "puntos seleccionados en el polígono",
		},
		NoPointsSelected: "No hay puntos seleccionados. Dibuja un polígono en el mapa primero.",
		SearchPoints: "Buscar puntos...",
		NoPointsMatch: "No se encontraron puntos que coincidan con la búsqueda",

		// Point Creation
		AddOnMap: "Agregar en el Mapa",
		AddOnMapHelp: "Haz click en el mapa para crear un punto",
		ManualForm: "Formulario Manual",
		ManualFormHelp: "Ingresa los datos manualmente",
		NewPoint: "Nuevo Punto de Visita",
		Identification: "Identificación",
		IdentificationPlaceholder: "Ej: PUNTO-001",
		Address: "Dirección",
		AddressPlaceholder: "Ej: Calle 72 #10-34",
		Latitude: "Latitud",
		Longitude: "Longitud",
		AddPoint: "Agregar Punto",
		MapClickInstructions: "Haz click en cualquier parte del mapa para crear un nuevo punto de visita",
		MapLoadError: "No se pudo cargar Google Maps. Por favor, recargue la página.",

		// Summary Tab
		Summary: "Resumen",
		AddFirstPoint: "Agregar Primer Punto",
		ReadyForClustering: "Listos para clustering",
		SelectedFromList: "Seleccionados de la Lista",
		CreatedManually: "Creados Manualmente",
		CreatedOnMap: "Creados en el Mapa",
		EditPoint: "Editar Punto",
		PointUpdated: "Punto actualizado exitosamente",
		PointDeleted: "Punto eliminado exitosamente",
		PointsDeleted: "{count} puntos eliminados exitosamente",
		AllPointsDeleted: "Todos los puntos han sido eliminados",
		RemoveAllSelected: "Eliminar Todos los Seleccionados",
		RemoveAllManual: "Eliminar Todos los Manuales",
		RemoveAllMapClick: "Eliminar Todos del Mapa",
		RemoveAllPoints: "Eliminar Todos los Puntos",
		ConfirmDeletePoint: "¿Estás seguro de eliminar el punto {point}?",
		ConfirmDeleteGroup: "¿Estás seguro de eliminar {count} puntos de {group}?",
		ConfirmDeleteAll: "¿Estás seguro de eliminar todos los {count} puntos? Esta acción no se puede deshacer.",

		// Filters
		DemandRange: "Rango de Demanda",

		// Demand Management
		DemandConfiguration: "Configuración de Demanda",
		DemandConfigHelp: "Configura la demanda (capacidad requerida) para cada punto de visita",
		QuickDemand: "Demanda Rápida",
		Apply: "Aplicar",
		QuickDemandApplied: "Demanda rápida aplicada a todos los puntos",
		EditDemands: "Editar Individualmente",
		DemandEditor: "Editor de Demandas",
		GlobalDemand: "Demanda Global",
		GlobalDemandHelp:
			"Establece una demanda predeterminada para todos los puntos. Luego puedes personalizar cada punto individualmente.",
		DefaultDemand: "Demanda por Defecto",
		ApplyToAll: "Aplicar a Todos",
		DemandAppliedToAll: "Demanda aplicada a todos los puntos exitosamente",
		RandomDemands: "Demandas Aleatorias",
		ResetDemands: "Restablecer Demandas",
		ConfirmRandomDemands: "¿Deseas generar demandas aleatorias (1-10) para todos los puntos?",
		RandomDemandsApplied: "Demandas aleatorias generadas exitosamente",
		ConfirmResetDemands: "¿Estás seguro de restablecer todas las demandas a 0?",
		DemandsReset: "Todas las demandas han sido restablecidas a 0",
		SaveDemands: "Guardar Demandas",
		DemandsSaved: "Demandas guardadas exitosamente",
		PointsWithDemand: "Puntos con Demanda",
		DemandInfo:
			"La demanda representa la capacidad o carga que requiere cada punto. Usa 0 si no necesitas este valor.",

		// Clustering
		CreateNew: "Crear Nuevo Clustering",
		Name: "Nombre del Clustering",
		NamePlaceholder: "Ej: Bogotá Centro - Zona Norte",
		NameRequired: "El nombre del clustering es requerido",
		NameTooLong: "El nombre no puede exceder 125 caracteres",
		NameLength: "Caracteres",
		EditName: "Editar Nombre del Clustering",
		Updated: "Clustering actualizado exitosamente",
		UpdateError: "Error al actualizar el clustering",
		FocusRemoved: "Foco removido exitosamente",
		TotalClusters: "Número de Clusters",
		Max10: "Máx: 10",
		MicroCluster: "Micro Cluster",
		MicroClustersHelp: "Subdivisiones dentro de cada cluster (opcional)",
		Generate: "Generar Clustering",
		Generating: "Generando",
		GeneratedSuccess: "¡Clustering generado exitosamente!",
		Reset: "Restablecer",
		ViewList: "Ver Lista",
		ViewAll: "Ver Todos",
		Cluster: "Cluster",
		Clusters: "Clusters",
		ClusterId: "ID del Cluster",
		Center: "Centro",
		Demand: "Demanda",
		Capacity: "Capacidad",
		Usage: "Uso",
		NoStatsFound: "No se encontraron estadísticas",
		ShowingItems: "Mostrando {start}-{end} de {total}",

		// Actions
		Regenerate: "Regenerar",
		ZoomToPoint: "Acercar al Punto",
		SearchClusters: "Buscar clusters...",
		NoClustersFound: "No se encontraron clusters",

		// Manual Selection & Point Selection
		ManualSelection: "Selección Manual",
		ManualSelectionHelp: "Dibuja un polígono en el mapa para seleccionar puntos específicos",
		SelectionTools: "Herramientas de Selección",
		SelectionToolsHelp: "Selecciona puntos usando múltiples métodos",
		StartSelection: "Iniciar Selección",
		CreateWithSelection: "Crear con Selección",
		DrawPolygonHelp: "Dibuja múltiples polígonos. Cada polígono agregará puntos a la selección.",
		DrawPolygons: "Dibujar Polígonos",
		FinishDrawing: "Terminar Dibujo",
		RemoveLastPolygon: "Eliminar Último",
		ClearPolygons: "Limpiar Polígonos",
		Polygons: "Polígonos",
		SelectPoints: "Seleccionar Puntos",
		AvailablePoints: "Puntos Disponibles",
		Available: "Disponibles",
		SelectPointsToStart: "Selecciona puntos para empezar (polígono, clic o selección completa)",
		QuickSelection: "Selección Rápida",
		SelectAll: "Seleccionar Todos",
		DeselectAll: "Deseleccionar Todos",
		ClickPointsHelp: "Haz clic en los puntos grises para agregarlos o en los verdes para quitarlos",
		ViewSelected: "Ver Seleccionados",
		PolygonMode: {
			Title: "Modo Polígono Activado",
			Text: "Dibuja múltiples polígonos para seleccionar puntos. Haz clic en 'Terminar' cuando finalices.",
		},
		PolygonSelected: "Polígono Seleccionado",
		PolygonSelectedHelp: "Doble-click para eliminar o usa el botón rojo",
		ConfirmRemovePolygon: "¿Eliminar este polígono? Los puntos dentro se deseleccionarán.",
		DeletePolygon: "Eliminar Polígono",
		PolygonRemoved: "Polígono Eliminado",
		RemainingPolygons: "Polígonos Restantes",
		PointsAdded: {
			Title: "Puntos Agregados",
			Text: "puntos agregados a la selección",
		},
		PointAdded: {
			Title: "Punto Agregado",
			Text: "agregado a la selección",
		},
		PointRemoved: {
			Title: "Punto Eliminado",
			Text: "Punto eliminado de la selección",
		},
		SelectionCleared: {
			Title: "Selección Limpiada",
			Text: "Se eliminaron todos los polígonos y la selección",
		},
		AllSelected: {
			Title: "Todos Seleccionados",
			Text: "puntos seleccionados",
		},
		AllDeselected: {
			Title: "Selección Limpiada",
			Text: "Todos los puntos han sido deseleccionados",
		},

		// Messages
		Success: {
			Title: "Clustering Creado",
			Text: "El clustering se ha creado exitosamente",
		},
		Deleted: {
			Title: "Clustering Eliminado",
			Text: "El clustering se ha eliminado exitosamente",
		},
		RegeneratedSuccess: "Clustering regenerado exitosamente",
		ValidationError: "Por favor completa todos los campos requeridos",
		PointsLimitExceeded: "Has superado el límite de 500 puntos",
		ErrorCreating: "Error al crear el clustering",
		ErrorLoadingList: "Error al cargar la lista de clusters",
		ErrorDeleting: "Error al eliminar el clustering",
		DemandDistribution: "Distribución de Demanda",
		// Confirmations
		ConfirmDelete: "¿Estás seguro de eliminar el clustering",
		ConfirmRegenerate: "¿Deseas regenerar el clustering",
		ConfirmReset: "¿Estás seguro de restablecer el clustering actual? Perderás todos los cambios no guardados.",

		// Loading messages
		Loaded: "Clustering cargado",
		ErrorLoading: "Error al cargar el clustering",
		ErrorDemandExceedsCapacity: "La demanda total {totalDemand} excede la capacidad total {totalCapacity}",
		SwitchedToClusters: "Vista cambiada a Clusters",
		SwitchedToMicroClusters: "Vista cambiada a Micro-clusters",
		// Validation
		validation: {
			name_required: "El nombre del clustering es requerido",
			total_clusters_required: "Debes especificar el número de clusters",
			total_clusters_max: "El número máximo de clusters es 10",
			points_required: "Debes cargar puntos para crear un clustering",
			points_max: "El número máximo de puntos es 500",
		},
	},
};
